"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2083],{

/***/ 72848:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ buyBox; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/constants/index.js
var constants = __webpack_require__(12468);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(68054);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Card/index.js + 2 modules
var Card = __webpack_require__(27439);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/index.js + 21 modules
var organisms = __webpack_require__(46514);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/BuyBox/buyBox.styles.js






const magaluBorderTop = styled_components_browser_esm/* css */.iv`
  background-image: linear-gradient(
    to right,
    #fcd000 0,
    #ff8a00 17%,
    #ff253a 34%,
    #ff37a8 51%,
    #a400e1 67%,
    #0086ff 83%,
    #00d604 100%
  );
  background-size: 100% 6px;
  background-repeat: no-repeat;
  background-position: top;
`;
const titleStyle = styled_components_browser_esm/* css */.iv`
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.1')(props)}px;
  color: ${props => (0,build_esm/* getTextColor */.uu)('base')(props)};
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  max-width: 97%;
`;
const displayContainer = {
  vertical: styled_components_browser_esm/* css */.iv`
    display: block;
  `,
  horizontal: styled_components_browser_esm/* css */.iv`
    display: flex;
    justify-content: space-between;
    align-items: center;
    & > div {
      flex-basis: 30%;
    }
    & > button {
      flex-basis: 200px;
      flex-shrink: 0;
    }
  `
};
const Display = (0,styled_components_browser_esm/* default */.ZP)(Card/* default */.ZP)`
  ${props => props.isMagalu && magaluBorderTop}
  background-color: ${props => (0,build_esm/* getPaletteColor */.ow)('background.lighter')(props)};
  padding: 1px 10px;
  margin: 0 2px 10px;
  border-radius: 6px;
  box-shadow: ${props => (0,build_esm/* themeGet */.R)('elevations.5')(props)};
  ${({
  displayMode
}) => displayMode && displayContainer[displayMode]}
`;
const Title = styled_components_browser_esm/* default.h2 */.ZP.h2`
  ${titleStyle}
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.1')(props)}px;
  font-weight: ${props => (0,build_esm/* themeGet */.R)('fontWeights.medium')(props)};
  margin: 10px 12px;
`;
const TitleDisplay = styled_components_browser_esm/* default.div */.ZP.div`
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  margin: 5px 5px 12px;
  & p {
    height: auto;
  }
`;
const contentContainer = {
  vertical: styled_components_browser_esm/* css */.iv`
    display: block;
  `,
  horizontal: styled_components_browser_esm/* css */.iv`
    display: flex;
    justify-content: space-between;
    align-items: center;
    & svg {
      ${props => props.isMagalu && styled_components_browser_esm/* css */.iv`
          width: 100px;
          height: auto;
        `}
    }
    & > div {
      ${({
    isMagalu
  }) => isMagalu && styled_components_browser_esm/* css */.iv`
          flex-grow: 1;
        `}
      flex-basis: 30%;
      flex-grow: 2;
    }
    & > button {
      flex-basis: 200px;
      flex-shrink: 0;
    }
  `
};
const Content = styled_components_browser_esm/* default.div */.ZP.div`
  border-radius: 6px;
  & > div {
    margin: 8px 5px 12px;
  }
  ${({
  displayMode
}) => displayMode && contentContainer[displayMode]}
`;
const Container = styled_components_browser_esm/* default.div */.ZP.div`
  border-radius: ${({
  exhibition
}) => exhibition === 'highlight' && '4px'};
  overflow: hidden;
  ${index_esm/* space */.Dh}
  ${index_esm/* color */.$_}
  ${index_esm/* layout */.bK}
  ${index_esm/* border */.Cg}
`;
const LogoMagaluIcon = (0,styled_components_browser_esm/* default */.ZP)(esm/* LogoMagalu */.ZGh).attrs(props => ({
  color: (0,build_esm/* getPaletteColor */.ow)('base')(props),
  width: 80,
  height: 40,
  viewBox: '0 0 60 14'
}))`
  vertical-align: middle;
  margin-top: 10px;
  margin-left: 5px;
`;
const shippingContainer = {
  horizontal: styled_components_browser_esm/* css */.iv`
    & svg + p {
      margin-right: ${props => (0,build_esm/* themeGet */.R)('fontSizes.1')(props)}px;
    }
  `
};
const ShippingList = (0,styled_components_browser_esm/* default */.ZP)(organisms/* ShippingList */.u0)`
  ${({
  displayMode
}) => displayMode && shippingContainer[displayMode]}
`;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/index.js + 33 modules
var molecules = __webpack_require__(39146);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/BuyBox/buyBox.js










const TITLE_BUYBOX = 'Escolha a melhor oferta';
const BUTTON_OK = 'Comprar agora';
const BUTTON_ERROR = 'Não disponível';

const isSellerMagalu = seller => (seller == null ? void 0 : seller.id) === constants/* DEFAULT_SELLER */.ig;

const BuyBoxItem = ({
  displayMode,
  offer,
  onClick,
  showSellerInDialog,
  disableSellerClick,
  onSellerClick,
  buttons,
  modal
}) => {
  const {
    seller,
    price,
    deliveryTypes,
    error
  } = offer;
  const isMagalu = isSellerMagalu(seller);
  const {
    content: ModalContent
  } = modal;
  return /*#__PURE__*/react.createElement(Display, {
    isMagalu: isMagalu,
    displayMode: displayMode,
    "data-testid": "buybox-card-container",
    hideLinkBorder: false,
    as: "div"
  }, /*#__PURE__*/react.createElement(Content, {
    isMagalu: isMagalu,
    displayMode: displayMode,
    "data-testid": "buybox-card-content"
  }, isMagalu && displayMode === 'vertical' && /*#__PURE__*/react.createElement(LogoMagaluIcon, {
    title: "Logo magalu",
    "data-testid": "magalogo"
  }), /*#__PURE__*/react.createElement(TitleDisplay, null, /*#__PURE__*/react.createElement(molecules/* Price */.tA, (0,esm_extends/* default */.Z)({
    display: 'galery',
    isList: true,
    showDiscount: true
  }, price))), /*#__PURE__*/react.createElement(TitleDisplay, null, seller && /*#__PURE__*/react.createElement(organisms/* SellerDelivery */.fP, {
    showDialog: showSellerInDialog,
    disableSellerClick: disableSellerClick,
    onOffersClick: onSellerClick,
    seller: seller,
    modal: Object.assign({}, modal, {
      content: modal.content && /*#__PURE__*/react.createElement(ModalContent, {
        seller: seller
      })
    })
  }))), deliveryTypes && /*#__PURE__*/react.createElement(ShippingList, {
    displayMode: displayMode,
    items: deliveryTypes
  }), /*#__PURE__*/react.createElement(atoms/* Button */.zx, {
    "data-testid": "buybox-button",
    onClick: e => onClick(e, offer),
    color: "secondary",
    startIcon: /*#__PURE__*/react.createElement(esm/* ShoppingBagFast */.tuM, {
      width: 32,
      height: 32
    }),
    m: '10px 0',
    disabled: Boolean(error),
    full: true
  }, error ? buttons.buttonError : buttons.buttonOk));
};

const BuyBoxList = props => {
  const {
    data,
    disableSellerClick,
    onClick,
    showSellerInDialog,
    onSellerClick,
    textButtons,
    displayMode,
    modal
  } = props,
        rest = (0,objectWithoutPropertiesLoose/* default */.Z)(props, ["data", "disableSellerClick", "onClick", "showSellerInDialog", "onSellerClick", "textButtons", "displayMode", "modal"]);

  const {
    buttonError = BUTTON_ERROR,
    buttonOk = BUTTON_OK,
    title = TITLE_BUYBOX
  } = textButtons;
  return /*#__PURE__*/react.createElement(Container, rest, /*#__PURE__*/react.createElement(Title, {
    "data-testid": "buybox-title"
  }, title), data.map((el, key) => /*#__PURE__*/react.createElement(BuyBoxItem, {
    displayMode: displayMode,
    key: key,
    offer: el,
    disableSellerClick: disableSellerClick,
    onSellerClick: onSellerClick,
    onClick: onClick,
    buttons: {
      buttonError,
      buttonOk
    },
    showSellerInDialog: showSellerInDialog,
    modal: modal
  })));
};

 false ? 0 : void 0;
 false ? 0 : void 0;
BuyBoxList.defaultProps = {
  displayMode: 'vertical',
  data: [],
  onClick: () => {},
  showSellerInDialog: false,
  onSellerClick: () => {},
  disableSellerClick: false,
  textButtons: {},
  modal: {}
};
/* harmony default export */ var buyBox = (BuyBoxList);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/BuyBox/index.js


/***/ }),

/***/ 33252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ filter_menu; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/FilterMenu/filter-menu.styles.js


const Container = styled_components_browser_esm/* default.div */.ZP.div`
  display: flex;
  align-items: center;
`;
const Title = styled_components_browser_esm/* default.p */.ZP.p`
  margin-right: 5px;
  color: ${props => (0,build_esm/* getTextColor */.uu)('scratched')(props)};
`;
const FilterBar = styled_components_browser_esm/* default.div */.ZP.div`
  background-color: ${props => (0,build_esm/* getBackgroundColor */.dF)('lighter')(props)};
  color: ${props => (0,build_esm/* getTextColor */.uu)('lightest')(props)};
  height: 2em;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.0')(props)}px;
  padding: 25px 0;
  border-bottom: 1px solid ${props => (0,build_esm/* getBorderColor */.kJ)('light')(props)};
`;
const Backward = styled_components_browser_esm/* default.span */.ZP.span`
  padding: ${props => (0,build_esm/* themeGet */.R)('fontSizes.3')(props)}px;
  cursor: pointer;
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.1')(props)}px;
  fill: ${props => (0,build_esm/* getTextColor */.uu)('scratched')(props)};
`;
const TitleSideCard = (0,styled_components_browser_esm/* default */.ZP)(Backward)`
  color: ${props => (0,build_esm/* getTextColor */.uu)('base')(props)};
`;
const Clear = (0,styled_components_browser_esm/* default */.ZP)(Backward)`
  color: ${props => props.count >= 1 ? (0,build_esm/* themeGet */.R)('palette.primary.base') : (0,build_esm/* getTextColor */.uu)('light')};
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/FilterMenu/filter-menu.text.js
const backLabel = (/* unused pure expression or super */ null && (`Voltar`));
const clearLabel = `Limpar tudo`;
const filterLabel = `Filtrar`;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Counter/index.js + 2 modules
var Counter = __webpack_require__(84022);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/index.js + 21 modules
var organisms = __webpack_require__(46514);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/List/index.js + 10 modules
var List = __webpack_require__(78012);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/FilterMenu/filter-menu.js








 // eslint-disable-next-line react/display-name

const renderCategoryFilterItem = categoryItemClick => (item, idx) => /*#__PURE__*/react.createElement(List/* default.Item */.Z.Item, (0,esm_extends/* default */.Z)({}, item, {
  key: item.id || idx,
  href: item.path || item.href,
  onClick: (item.path || item.href) && (e => {
    categoryItemClick(e, item);
  }),
  fontWeight: !(item.path || item.href) ? 'bold' : undefined,
  as: (item.path || item.href) && 'a',
  startIcon: item.icon,
  endIcon: !item.icon && (item.path || item.href) && 'ChevronRight'
}), item.label);

const FilterMenu = ({
  onOpen,
  onClose,
  onClear,
  onClickOutside,
  onShowDetail,
  onItemClick,
  visible,
  filters,
  count
}) => {
  const {
    attributeFilter: attributeItemClick,
    reviewFilter: reviewItemClick,
    categoryFilter: categoryItemClick,
    priceFilter: priceApply
  } = onItemClick;

  const renderMultiple = ({
    slug,
    values,
    label,
    position,
    filterSelected,
    showFilterInput
  }) => /*#__PURE__*/react.createElement(organisms/* FilterItemAttribute */.G4, {
    key: slug,
    items: values,
    label: label,
    position: position,
    onItemClick: attributeItemClick,
    filterSelected: filterSelected,
    showFilterInput: showFilterInput,
    fullScreen: true,
    onClick: onShowDetail
  });

  const renderHierarchical = ({
    position,
    label,
    values
  }) => /*#__PURE__*/react.createElement(organisms/* FilterItemContainer */.jm, {
    label: label,
    position: position,
    fullScreen: true,
    onClick: onShowDetail
  }, /*#__PURE__*/react.createElement(List/* default */.Z, null, values == null ? void 0 : values.map(renderCategoryFilterItem(categoryItemClick))));

  const renderUnique = ({
    slug,
    values,
    label,
    position,
    filterSelected,
    showFilterInput
  }) => /*#__PURE__*/react.createElement(organisms/* FilterItemReview */.pZ, {
    position: position,
    key: slug,
    items: values,
    label: label,
    onItemClick: reviewItemClick,
    filterSelected: filterSelected,
    showFilterInput: showFilterInput,
    fullScreen: true,
    onClick: onShowDetail
  });

  const renderPrice = item => {
    const {
      position,
      slug,
      label,
      min,
      max,
      selectedMin,
      selectedMax
    } = item;
    return /*#__PURE__*/react.createElement(organisms/* FilterItemPrice */.aw, {
      position: position,
      key: slug,
      label: label,
      onApply: priceApply,
      fullScreen: true,
      onClick: onShowDetail,
      min: min,
      max: max,
      selectedMin: selectedMin,
      selectedMax: selectedMax,
      item: item
    });
  };

  const renderByType = {
    multiple: renderMultiple,
    hierarchical: renderHierarchical,
    unique: renderUnique,
    priceRange: renderPrice
  };
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Container, {
    onClick: onOpen,
    "data-testid": "filter-menu-button"
  }, /*#__PURE__*/react.createElement(Counter/* default */.Z, {
    count: count,
    mr: '4px'
  }), /*#__PURE__*/react.createElement(Title, null, filterLabel)), /*#__PURE__*/react.createElement(organisms/* Sidebar */.YE, {
    direction: "right",
    visible: visible,
    onClickOutside: onClickOutside
  }, /*#__PURE__*/react.createElement(FilterBar, null, /*#__PURE__*/react.createElement(Backward, {
    onClick: onClose,
    role: "button",
    tabIndex: "0",
    "data-testid": "close-menu"
  }, /*#__PURE__*/react.createElement(esm/* Close */.x8P, {
    height: "20"
  })), /*#__PURE__*/react.createElement(TitleSideCard, null, filterLabel), /*#__PURE__*/react.createElement(Clear, {
    onClick: count >= 1 ? onClear : null,
    onKeyDown: count >= 1 ? onClear : null,
    role: "button",
    tabIndex: "-1",
    "data-testid": "clear-filters",
    count: count
  }, clearLabel)), /*#__PURE__*/react.createElement(react.Fragment, null, filters != null && filters.length ? filters.map(filterItem => {
    const {
      componentType
    } = filterItem;
    return renderByType[componentType](filterItem);
  }) : null)));
};

 false ? 0 : void 0;
FilterMenu.defaultProps = {
  onClear: () => {},
  onClose: () => {},
  onOpen: () => {},
  onClickOutside: () => {},
  visible: false,
  filters: {
    attributeFilters: [],
    reviewFilter: {}
  },
  count: 0,
  onItemClick: {
    attributeFilter: () => ({}),
    reviewFilter: () => ({})
  },
  onShowDetail: () => {}
};
/* harmony default export */ var filter_menu = (FilterMenu);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/FilterMenu/index.js


/***/ }),

/***/ 99852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ financial_services; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/FinancialServices/financial-services.data.js
/* eslint-disable sonarjs/no-duplicate-string */
const Title = `Serviços`;
const ProtectLabel = `Proteja o seu produto por muito mais tempo!`;
const RobberyAndTheftLabel = `Roubo e Furto`;
const ProtectRobberyAndTheft = `Proteção ${RobberyAndTheftLabel}`;
const ExtendedWarrantyLabel = `Garantia Estendida Original Ampliada`;
const PaymentsWayLabel = `Formas de pagamentos`;
const ProfitsLabels = (/* unused pure expression or super */ null && ([`- Mais tempo de garantia além do fabricante`, `- Consertos utilizando peças genuínas`, `- Mais de 3 mil assistências técnicas em todo o Brasil`, `- Concorra a R$ 5.000,00 durante 3 meses`]));
const ServicesPriority = [5, 3, 4];
const RobberyTerms = [{
  id: 'rs1',
  title: 'SEGURO PROTEÇÃO ROUBO E FURTO QUALIFICADO COM QUEBRA ACIDENTAL',
  content: [{
    text: [{
      content: 'As Condições Gerais desse seguro poderão ser consultadas a qualquer momento, através do site '
    }]
  }, {
    link: 'http://condicoesgerais.bnpparibascardif.com.br/rf',
    text: 'condicoesgerais.bnpparibascardif.com.br/rf'
  }]
}, {
  id: 'rs11',
  title: 'CARACTERÍSTICAS DO SEGURO',
  content: [{
    text: [{
      content: 'Garantir a reposição ou o reparo do bem segurado.'
    }]
  }]
}, {
  id: 'rs2',
  title: 'TIPO DE COBERTURA',
  content: [{
    text: [{
      content: 'Roubo, Furto Qualificado e Quebra Acidental de Aparelhos Móveis'
    }]
  }]
}, {
  id: 'rs3',
  title: 'SINISTROS',
  content: [{
    text: [{
      content: 'Em caso de sinistro, o Segurado deverá comunicar a ocorrência do defeito à Seguradora, através do site '
    }]
  }, {
    link: 'https://luizaseg.acioneseuseguro.com.br/',
    text: 'https://luizaseg.acioneseuseguro.com.br/'
  }, {
    text: [{
      content: ', ou entrar em contato com a Central de Atendimento através do telefone informado abaixo.'
    }]
  }, {
    text: [{
      content: 'Fica estabelecido o prazo de até 30 (trinta) dias para o pagamento de indenização devida pelo presente Contrato de Seguro, contados a partir da entrega de todos os documentos básicos previstos. Caso haja solicitação de nova documentação e/ou informação complementar, o prazo para pagamento do sinistro será suspenso, voltando a correr a partir do dia útil subsequente àquele em que forem completamente atendidas as exigências.'
    }]
  }]
}, {
  id: 'rs4',
  title: 'SORTEIO DE CAPITALIZAÇÃO',
  content: [{
    text: [{
      content: 'Haverá sorteio Mensal durante 3 meses, no valor liquido de R$ 5.062,50, realizado pela Loteria Federal. A participação ocorrerá por meio do seu Número da Sorte expresso no Bilhete de Seguro, desde que o pagamento do seguro esteja em dia. O regulamento da capitalização pode ser consultado a qualquer tempo através do site: www.regulamentos.bnpparibascardif.com.br'
    }]
  }, {
    text: [{
      content: 'Icatu Capitalização S.A., CNPJ: 74.267.170/1000-73, Processo SUSEP: 15414.900393/2019-87, Ouvidoria Icatu Seguros: 0800 286 0047. Modalidade Incentivo. “É proibida a venda de títulos de capitalização a menores de dezesseis anos - Art.3º, I do Código Civil '
    }]
  }, {
    link: 'http://www.icatuseguros.com.br',
    text: 'http://www.icatuseguros.com.br'
  }, {
    text: [{
      content: '. É proibida a venda de títulos de capitalização a menores de dezesseis anos - Art. 3o, I do Código Civil.'
    }]
  }]
}, {
  id: 'rs5',
  title: 'EXCLUSÕES GERAIS',
  content: [{
    text: [{
      content: 'Todos os riscos excluídos que constam no bilhete de seguro do bem segurado, também estarão automaticamente excluídos deste seguro. Os danos causados por atos ilícitos dolosos ou por culpa grave equiparável ao dolo, praticados pelo segurado, pelo beneficiário ou representante legal de um ou de outro, estarão excluídos.'
    }]
  }]
}, {
  id: 'rs6',
  title: 'INFORMAÇÕES ADICIONAIS',
  content: [{
    text: [{
      content: 'A contratação do Seguro é opcional e é proibido condicionar desconto no preço do bem à aquisição do seguro; O Segurado deverá guardar o certificado de garantia do fabricante; O Segurado poderá desistir do seguro no prazo de 7 dias corridos a contar da emissão do bilhete, através da Central de Atendimento informada neste documento ou representante de seguro; Caso haja a necessidade de reparo no período de garantia do fabricante, deverá entrar em contato com o fabricante. Número de atendimento do fabricante vide manual de garantia do fabricante.'
    }]
  }]
}, {
  id: 'rs7',
  title: 'CENTRAL DE ATENDIMENTO',
  content: [{
    text: [{
      content: 'SAC (cancelamento, reclamações e informações sobre seguro): 0800 545 4040. '
    }, {
      content: 'Abertura e acompanhamento de sinistro: 3003 4288 (Capitais e regiões metropolitanas) ou 0800 200 0940 (demais localidades). '
    }, {
      content: 'Deficiente auditivo:0800 727 2482 (atendimento todos os dias, 24h). Caso não esteja satisfeito com a resposta fornecida pelo SAC, entre em contato com a Ouvidoria: 0800 727 2482 - Dias úteis, das 9h às 18 horas (horário de Brasília) exceto feriados ou acesse ouvidoria.bnpparibascardif.com.br.'
    }]
  }]
}, {
  id: 'rs8',
  title: 'SEGURADORA',
  content: [{
    text: [{
      content: 'Cardif do Brasil Seguros e Garantias S/A, CNPJ: 08.279.191/0001-84, com endereço na Avenida Presidente Juscelino Kubitscheck, Nº1909, Torre Sul, 8º andar, São Paulo/SP, CEP: 04543-907 ou https://www.bnpparibascardif.com.br/'
    }]
  }]
}, {
  id: 'rs9',
  title: 'CORRETORA',
  content: [{
    text: [{
      content: 'Viotto Corretora de Seguros e Previdência Ltda. CNPJ: 56.170.061/0001-51. Registro SUSEP: 10.0059706.'
    }]
  }]
}, {
  id: 'rs10',
  title: 'DISPOSIÇÕES GERAIS',
  content: [{
    text: [{
      content: 'Ouvidoria - Finalidade e Forma de Utilização: 0800 727 2482 ou https://www.luizaseg.com.br/. “O registro do produto é automático e não representa aprovação ou recomendação por parte da Susep”. “A adesão ao seguro é opcional”. “O segurado poderá consultar a situação cadastral de seu corretor de seguros, no site www.susep.gov.br, por meio do número de seu registro na SUSEP, nome completo, CNPJ ou CPF”. ”A aceitação do seguro estará sujeita à análise do risco”. “As condições contratuais/regulamento deste produto encontram-se registradas na SUSEP de acordo com o número de processo constante da apólice/proposta e poderão ser consultadas no endereço eletrônico www.susep.gov.br”. “Em atendimento à Lei 12.741/12 informamos que incidem as alíquotas de 0,65% de PIS/Pasep e de 4% de COFINS sobre os prêmios de seguros/as contribuições a planos de caráter previdenciário/os pagamentos destinados a planos de capitalização, deduzidos do estabelecido em legislação específica”. “O registro do produto é automático e não representa aprovação ou recomendação por parte da Susep”. "É dever do intermediário disponibilizar ao cliente formal e previamente à contratação do seguro, o montante de sua remuneração e o prêmio do seguro. A distribuição dos seguros por meio do Magazine Luiza é realizada com exclusividade. Saiba mais sobre a privacidade dos seus dados pessoais e como serão mantidos em segurança: acesse https://www.luizaseg.com.br/lgpd.php;". A FRAUDE CONTRA SEGUROS É CRIME, DENUNCIE (21) 2253-1177 OU 181 - WWW.FENASEG.ORG.BR. Atendimento SUSEP: 0800 021 8484 - Dias úteis das 9:30 às 17:00 Por meio do Acordo Operacional celebrado entre as empresas acima (“ SEGURADORA”) e (“REPRESENTANTE”), a SEGURADORA confere a REPRESENTANTE poderes para: Realizar a oferta e promoção de Seguros, inclusive por meios remotos, em nome da SEGURADORA; Emitir bilhetes de seguro em nome da SEGURADORA e entregá-lo ao segurado; Coletar e fornecer à SEGURADORA os dados cadastrais e de documentação de proponentes, segurados, beneficiários e corretores de seguros e seus prepostos; Recolher os prêmios de Seguro, em nome da SEGURADORA, e repassá-los integralmente à SEGURADORA; Orientar e assistir aos segurados e seus beneficiários, no que compete aos contratos de Seguro, inclusive por meios remotos, em nome da SEGURADORA; Orientar e assistir aos corretores de seguros e seus prepostos, se for o caso; Dar apoio logístico e administrativo à SEGURADORA, visando a manutenção dos contratos de seguros e outros serviços, inclusive, controle e processamento de dados das operações pactuadas em nome da SEGURADORA.'
    }]
  }]
}];
const ExtendedWarrantyTerms = [{
  id: 'ce1',
  title: 'SEGURO DE GARANTIA ESTENDIDA ORIGINAL AMPLIADA',
  content: [{
    text: [{
      content: 'Processo Susep: 15414.900275/2014-64, garantido pela Cardif do Brasil. Seguros e Garantias S.A. CNPJ: 08.279.191/0001-84, com endereço na Avenida Presidente Juscelino Kubitscheck, No 1909, Torre Sul, 8o andar, São Paulo/SP, CEP: 04543-907 ou '
    }]
  }, {
    link: 'http://www.cardif.com.br',
    text: 'www.cardif.com.br'
  }]
}, {
  id: 'ce2',
  title: 'CARACTERÍSTICAS DO SEGURO',
  content: [{
    text: [{
      content: 'Este seguro de Garantia Estendida Original Ampliada tem por objetivo, caso o segurado queira e possua o pagamento do seguro em dia, além de estender a garantia de  fábrica do bem, contemplar as coberturas adicionais de Danos Elétricos e Oxidação.'
    }]
  }]
}, {
  id: 'ce3',
  title: 'TIPO DE COBERTURA',
  content: [{
    text: [{
      content: 'Extensão de Garantia Original.'
    }]
  }]
}, {
  id: 'ce4',
  title: 'SEGURADORA',
  content: [{
    text: [{
      content: 'Cardif do Brasil Seguros e Garantias S.A. CNPJ: 08.279.191/0001-84 com endereço na Avenida Presidente Juscelino Kubitscheck, Nº1909, Torre Sul, 8º andar, São Paulo/SP, CEP: 04543-907 ou www.cardif.com.br.'
    }]
  }]
}, {
  id: 'ce5',
  title: 'REPRESENTANTE DE SEGURO',
  content: [{
    text: [{
      content: 'Magazine Luiza S.A., CNPJ: 47.960.950/0001-21.'
    }]
  }]
}, {
  id: 'ce6',
  title: 'CORRETORA',
  content: [{
    text: [{
      content: 'Viotto Corretora de Seguros e Previdência Ltda, CNPJ: 56.170.061/0001-51 e Registro SUSEP:202069682.'
    }]
  }]
}, {
  id: 'ce7',
  title: 'SORTEIO DE CAPITALIZAÇÃO',
  content: [{
    text: [{
      content: 'Haverá sorteio mensal durante 3 meses, no valor líquido de R$5.062,50, realizado pela Loteria Federal. A participação ocorrerá por meio do seu Número da Sorte expresso no Bilhete de Seguro, desde que o pagamento do seguro esteja em dia. O regulamento da capitalização pode ser consultado a qualquer tempo através do '
    }]
  }, {
    link: 'http://siteregulamentos.bnpparibascardif.com.br',
    text: 'siteregulamentos.bnpparibascardif.com.br.'
  }, {
    text: [{
      content: `Icatu Capitalização S.A., CNPJ: 74.267.170/1000-73, Processo SUSEP: 15414.900393/2019-87, Ouvidora Icatu Seguros: 0800 286 0047, Modalidade Incentivo. "É proibida a venda de títulos de capitalização a menores de dezesseis anos - Art. 3° I do Código Civil".http://www.icatuseguros.com.brÉ proibida a venda de títulos de capitalização a menores de dezesseis anos - Art. 3o, I do Código Civil.`
    }]
  }]
}, {
  id: 'ce8',
  title: 'EXCLUSÕES GERAIS: SITUAÇÕES QUE NÃO SERÃO ATENDIDAS PELO SEU SEGURO.',
  content: [{
    text: [{
      content: `Não estará coberto tudo que estiver previsto ou não abrangido no Certificado de Garantia e/ou no Manual de Garantia de fábrica do bem, inclusive aquilo que deixar de ser garantido e/ou deter a cobertura oferecida durante prazo de garantia do fabricante,exceto os defeitos decorrentes de Danos Elétricos Oxidação. Além dos riscos excluídos descritos acima, também são excluídos deste seguro os atos ilícitos dolosos ou por culpa grave equiparável ao dolo, que agravem intencionalmente o risco, podendo ser considerados fraude, ou má-fé,por ação ou omissão, praticados pelo segurado, pelo beneficiário ou pelo representante de um ou de outro e,caso o segurado seja uma pessoa jurídica, essas exclusões aplicam-se também aos sócios controladores, aos seus dirigentes e administradores legais, aos beneficiários e aos seus respectivos representantes legais. `
    }]
  }]
}, {
  id: 'ce9',
  title: 'EXCLUSÕES ESPECÍFICAS: SITUAÇÕES POR COBERTURA CONTRATADA QUE NÃO SERÃO ATENDIDAS  PELO SEU SEGURO. ',
  content: [{
    text: [{
      content: 'Danos Elétricos'
    }, {
      content: 'a)Fusíveis, resistências de aquecimento, lâmpadas de qualquer tipo, tubos catódicos de equipamentos eletrônicos e quaisquer outros componentes, que,por sua natureza,necessitem de trocas periódicas.'
    }, {
      content: 'b)Perdas,danos ou avarias ao bem segurado por combustão e/ou aquecimento espontâneo;'
    }, {
      content: 'c)Recomposição de registros e documentos, arquivos, softwares de qualquer natureza, bem como seus periféricos, configurações, formatações, backups, disquetes etc. '
    }, {
      content: 'd) Danos causados a programas de informática qualquer tipo,ficando entendido,no entanto,que nos casos de perda total de microcomputadores em virtude de evento coberto, os programas que acompanharam o equipamento quando da aquisição estarão garantidos,exceto os programas opcionalmente adquiridos.'
    }, {
      content: 'd) Danos causados a programas de informática qualquer tipo,ficando entendido,no entanto,que nos casos de perda total de microcomputadores em virtude de evento coberto, os programas que acompanharam o equipamento quando da aquisição estarão garantidos,exceto os programas opcionalmente adquiridos.'
    }, {
      content: 'Oxidação:'
    }, {
      content: 'a)Qualquer defeito coberto provocado intencionalmente;'
    }, {
      content: 'b)Partes,peças e componentes que são consumíveis ou sofram desgaste natural, independente da origem do problema; '
    }, {
      content: 'c) Produto cujo número de identificação, do chassi ou de série tenha sido removido ou adulterado;'
    }, {
      content: 'd) Manchas, desgastes ou de outras falhas consequentes da aplicação de produtos impermeabilizantes; '
    }, {
      content: 'e) Danos estéticos como riscos, quebras, trincas, amassamentos, arranhaduras etc.), mesmo decorrentes de Danos Elétricos.'
    }]
  }]
}, {
  id: 'ce10',
  title: 'SINISTROS',
  content: [{
    text: [{
      content: `Em caso de sinistro, o Segurado deverá comunicar a ocorrência do defeito à Seguradora, por meio do site www.acioneseuseguro.com.br, ou entrar em contato com  a Central de Atendimento por meio do telefone informado abaixo. Nesta ocasião, o segurado receberá um número de sinistro, que deverá ser informado à assistência  técnica indicada.A seguradora terá até 30 dias corridos para concluir o atendimento, a contar da entrega do bem segurado à assistência técnica pelo segurado, acompanhado do Bilhete de Seguro, Documento Fiscal de Aquisição do Bem Segurado, CPF ou outro documento de identificação.Se o bem segurado apresentar  algum defeito funcional (chamado daqui por diante apenas de “defeito’’) durante a vigência do seguro, a indenização se dará por meio do reparo do bem, que será feito pela  assistência técnica. O seguro cobre o valor das peças de reposição e o custo da mão-de-obra. Caso o bem não possa ser consertado, será feita a sua reposição por outro  igual ou com funcionalidades semelhantes, que pode ser novo ou recondicionado. Se não for possível nem o reparo e nem a reposição do bem, o segurado receberá o  pagamento do valor que pagou por ele, de acordo com a nota fiscal de compra. `
    }]
  }]
}, {
  id: 'ce11',
  title: 'CENTRAL DE ATENDIMENTO',
  content: [{
    text: [{
      content: 'Central de atendimento: SAC (Cancelamentos,reclamações e informações do seguro): 0800 545 4040. Abertura e Acompanhamento de Sinistros: 3003 4288 (Capitais e regiões metropolitanas) ou 0800 200 0940 (Demais localidades). Deficiente Auditivo: 0800 725 0645,atendimento todos os dias, 24 horas. Ouvidoria Cardif: 0800 727 2482, atendimento em dias úteis, das 9h às 18h (horário de Brasília) exceto feriados, ou ouvidoria.bnpparibascardif.com.br'
    }]
  }]
}, {
  id: 'ce12',
  title: 'DISPOSIÇÕES GERAIS',
  content: [{
    text: [{
      content: `Caso não esteja satisfeito com a resposta fornecida pelo SAC, entre em contato com a Ouvidoria: 0800 727 2482 - Dias úteis, das 9h às 18 horas (horário de Brasília) exceto feriados ou acesse ouvidoria.bnpparibascardif.com.br e também www.consumidor.gov.br. A contratação de seguro é opcional, sendo possível a desistência do contrato em até 7 (sete) dias corridos com a devolução integral do valor pago. É proibido condicionar desconto no preço do bem à aquisição do seguro. A comercialização de seguros é fiscalizada pela SUSEP. www.susep.gov.br – 0800 021 8484. O registro do produto é automático e não representa aprovação ou recomendação por parte da Susep. É dever do intermediário disponibilizar ao cliente formal e previamente à contratação do seguro, o montante de sua remuneração e o prêmio do seguro. A distribuição dos seguros por meio do Magazine Luiza é realizada com exclusividade. Saiba mais sobre a privacidade dos seus dados pessoais e como serão mantidos em segurança: acesse bnpparibascardif.com.br/lei-geal-de-protecao-de-dados. O segurado poderá consultar a situação cadastral de seu corretor de seguros, no site www.susep.gov.br por meio do número de seu registro na SUSEP, nome completo, CNPJ ou CPF. O segurado deverá guardar o certificado de garantia do fabricante. Caso haja a necessidade de reparo no período de garantia do fabricante, deverá entrar em contato com o fabricante. Número de atendimento do fabricante vide manual de garantia do fabricante. As condições contratuais/regulamento deste produto encontram-se registradas na SUSEP de acordo com o número de processo constante da apólice/proposta e poderão ser consultadas no endereço eletrônico www.susep.gov.br. Em atendimento à Lei 12.741/12 informamos que incidem as alíquotas de 0,65% de PIS/Pasep e de 4% de COFINS sobre os prêmios de seguros/as contribuições a planos de caráter previdenciário/os pagamentos destinados a planos de capitalização, deduzidos do estabelecido em legislação específica. A FRAUDE CONTRA SEGUROS É CRIME, DENUNCIE (21) 2253-1177 OU 181 - WWW.FENASEG.ORG.BR. Atendimento SUSEP:0800 021 8484 - Dias úteis das 9:30 às 17:00. Por meio do Acordo Operacional celebrado entre as empresas acima ("SEGURADORA") e ("REPRESENTANTE"), a SEGURADORA confere a REPRESENTANTE poderes para: Realizar a oferta e promoção de Seguros, inclusive por meios remotos, em nome da SEGURADORA; Recepcionar propostas de seguros e/ou emitir bilhetes de seguro em nome da SEGURADORA e entregá-lo ao segurado; Coletar e fornecer à SEGURADORA os dados cadastrais e de documentação de proponentes, segurados, beneficiários e corretores de seguros e seus prepostos; Recolher os prêmios de Seguro, em nome da SEGURADORA, e repassá-los integralmente à SEGURADORA; Orientar e assistir aos segurados e seus beneficiários, no que compete aos contratos de Seguro, inclusive por meios remotos, em nome da SEGURADORA; Recepcionar propostas de seguros e/ou emitir bilhetes de seguro em nome da SEGURADORA e entregá-lo ao segurado; Coletar e fornecer à SEGURADORA os dados cadastrais e de documentação de proponentes, segurados, beneficiários e corretores de seguros e seus prepostos; Recolher os prêmios de Seguro, em nome da SEGURADORA, e repassá-los integralmente à SEGURADORA; Orientar e assistir aos segurados e seus beneficiários, no que compete aos contratos de Seguro, inclusive por meios remotos, em nome da SEGURADORA;`
    }]
  }]
}];
const ExtendedWarrantyRegulationTitle = `${ExtendedWarrantyLabel}`;
const RobberyRegulationTitle = `Seguro ${RobberyAndTheftLabel} Qualificado`;
const RobberyRegulation = 'Seguro Garantia Estendida Original, orientamos a leitura das condições gerais do seguro no link www.luizaseg.com.br. Seguro garantido pela Luizaseg Seguros S/A, CNPJ: 07.746.953/0001-42, Processo Susep Nº 15414.900276/2014-17. Representante de Seguro: Magazine Luiza S/A, CNPJ 47.960.950/0001-21. Corretora: Viotto Corretora de Seguros e Previdência LTDA, CNPJ 56.170.061/0001-51, Registro SUSEP 10.0059706. “Adesão Opcional”. "A  contratação de seguro é opcional, sendo possível a desistência do contrato em até 7 (sete) dias corridos com a devolução integral do valor pago." "É proibido condicionar desconto no preço do bem à aquisição do seguro." Título de Capitalização garantido Capitalização: Icatu Capitalização S.A., CNPJ: 74.267.170/0001-73 Processo SUSEP: 15414.900051/2018-86. Ouvidoria Icatu Seguros: 0800 286 0047. Consulte o regulamento do sorteio no site: "http://www.icatuseguros.com.br". Modalidade: Incentivo. Prêmio no valor líquido de R$ 5.062,50. Promoção válida por 3 meses. Sorteios: Mensais a partir do último sábado do mês subsequente a adesão.  Consulte o regulamento no link regulamentos.bnpparibascardif.com.br.  "É proibida a venda de títulos de capitalização a menores de dezesseis ano - Art.3º, I do Código Civil".  "A comercialização de seguro é fiscalizada pela Susep. www.susep.gov.br - 0800 021 8484". "A aprovação do Plano pela Susep não implica, por parte da Autarquia, em incentivo ou recomendação à sua aquisição. "Caso não esteja satisfeito com a resposta fornecida pelo SAC, entre em contato com a Ouvidoria : 0800 727 2482 - Dias úteis, das 9h as 18 horas (horário de Brasilia) exceto feriados ou bnpparibascardif.com.br/ouvidoria.';
const ExtendedWarrantyRegulation = `Processo Susep: 15414.900275/2014-64, garantido pela Cardif do Brasil. Seguros e Garantias S.A. CNPJ: 08.279.191/0001-84, com endereço na Avenida Presidente Juscelino Kubitscheck, No 1909, Torre Sul, 8o andar, São Paulo/SP, CEP: 04543-907 ou www.cardif.com.br. Orientamos a leitura das condições gerais no link https://bnpparibascardif.com.br/condicoes-gerais. REPRESENTANTE DE SEGURO Magazine Luiza S.A., CNPJ: 47.960.950/0001-21. CORRETORA
  Viotto Corretora de Seguros e Previdência Ltda, CNPJ: 56.170.061/0001-51 e Registro SUSEP:202069682.
  A contratação de seguro é opcional, sendo possível a desistência do contrato em até 7 (sete) dias corridos com a devolução integral do valor pago. É proibido condicionar desconto no preço do bem à aquisição do seguro.
  Haverá sorteio mensal durante 3 meses, no valor líquido de R$5.062,50, realizado pela Loteria Federal. A participação ocorrerá por meio do seu Número da Sorte expresso no Bilhete de Seguro, desde que o pagamento do seguro esteja em dia. O regulamento da capitalização pode ser consultado a qualquer tempo através do siteregulamentos.bnpparibascardif.com.br. Icatu Capitalização S.A., CNPJ: 74.267.170/1000-73, Processo SUSEP: 15414.900393/2019-87, Ouvidora Icatu Seguros: 0800 286 0047, Modalidade Incentivo. "É proibida a venda de títulos de capitalização a menores de dezesseis anos - Art. 3° I do Código Civil".http://www.icatuseguros.com.br.
  É proibida a venda de títulos de capitalização a menores de dezesseis anos - Art. 3o, I do Código Civil.  A comercialização de seguros é fiscalizada pela SUSEP. www.susep.gov.br – 0800 021 8484.  O registro do produto é automático e não representa aprovação ou recomendação por parte da Susep. Caso não esteja satisfeito com a resposta fornecida pelo SAC, entre em contato com a Ouvidoria: 0800 727 2482 - Dias úteis, das 9h às 18 horas (horário de Brasília) exceto feriados ou acesse ouvidoria.bnpparibascardif.com.br e também www.consumidor.gov.br.`;
const ConciseMessage = `Ao clicar em contratar serviço e ir para sacola você aceita as condições do seguro`;
const Conditions = `${RobberyAndTheftLabel} e Forma de pagamento`;
const PaymentsWayTerms = [{
  id: 'pw1',
  title: 'Termo de Autorização de cobrança de Prêmio de Seguro',
  content: [{
    text: [{
      content: 'Eu, proponente '
    }, {
      content: '{description} '
    }, {
      content: 'autorizo que o pagamento do prêmio de seguro no valor de '
    }, {
      content: '{totalPrice} ',
      bold: true
    }, {
      content: 'seja realizado em conjunto com o pagamento do(s) produto(s)/serviço(s) ora adquirido(s).'
    }]
  }]
}, {
  id: 'pw2',
  content: [{
    text: [{
      content: 'Início e Término da vigência do seguro: ',
      bold: true
    }, {
      content: 'Data especificada no Bilhete de Seguro que você receberá após a conclusão da compra, quando o Termo estará disponível com os dados completos, refletindo sua opção prévia e autorização de cobrança de prêmio.'
    }]
  }]
}, {
  id: 'pw3',
  content: [{
    text: [{
      content: 'Declaro ter prévia ciência das informações mínimas obrigatórias disponibilizadas antes da contratação do seguro acompanhadas da íntegra das Condições Gerais do presente Seguro e tenho conhecimento que também poderei consultá-la a qualquer momento através do site www.luizaseg.com.br. Declaro também que foram integralmente cumpridas as regras de conduta que devem ser praticadas pelos corretores de seguros e demais intermediários no relacionamento com o cliente, previstas na legislação vigente.'
    }]
  }]
}, {
  id: 'pw4',
  content: [{
    text: [{
      content: 'Notas :',
      bold: true
    }, {
      content: 'O segurado poderá desistir do seguro contratado no prazo de 7 (sete) dias corridos a contar da assinatura da proposta, no caso de contratação por apólice individual, ou da emissão do bilhete, no caso de contratação por bilhete, ou do efetivo pagamento do prêmio, o que ocorrer por último. No caso de pagamento de prêmio fracionado, considera-se o pagamento da primeira parcela como o efetivo pagamento.'
    }]
  }]
}, {
  id: 'pw5',
  financialService: 'extendedWarranty',
  content: [{
    text: [{
      content: 'Seguradora: Luizaseg Seguros S/A. CNPJ: 07.746.953/0001-42. Código Susep: 0206-2. Processo Susep: 15414.900276/2014-17. Ramo(s): 0195. Representante de Seguro: Magazine Luiza S/A CNPJ: 47.960.950/0001-21. Remuneração: '
    }, {
      content: '{extendedWarrantyPercentage} - '
    }, {
      content: '{extendedWarrantyAmount} '
    }, {
      content: '"A Magazine Luiza possui participação de 50% na Luizaseg Seguros S.A." Corretora: Viotto Corretora de Seguros e Previdência Ltda. CNPJ: 56.170.061/0001-51. Registro SUSEP: 10.0059706. Remuneração: 0,03%.'
    }]
  }]
}, {
  id: 'pw6',
  financialService: 'certainExchange',
  content: [{
    text: [{
      content: 'Seguradora: Luizaseg Seguros S/A. CNPJ: 07.746.953/0001-42. Código Susep: 0206-2. Processo Susep: 15414.900276/2014-17. Ramo(s): 0195. Representante de Seguro: Magazine Luiza S/A CNPJ: 47.960.950/0001-21. Remuneração: '
    }, {
      content: '{certainExchangePercentage} - '
    }, {
      content: '{certainExchangeAmount} '
    }, {
      content: '"A Magazine Luiza possui participação de 50% na Luizaseg Seguros S.A." Corretora: Viotto Corretora de Seguros e Previdência Ltda. CNPJ: 56.170.061/0001-51. Registro SUSEP: 10.0059706. Remuneração: 0,03%.'
    }]
  }]
}, {
  id: 'pw7',
  financialService: 'robberyAndTheft',
  content: [{
    text: [{
      content: 'Seguradora: Cardif do Brasil Seguros e Garantias S.A. CNPJ: 08.279.191/0001-84 Código SUSEP: 0293-3 Processo SUSEP: 15414.900738/2014-98 Ramo: 71. Representante de Seguro: Magazine Luiza S/A CNPJ: 47.960.950/0001-21. Remuneração: '
    }, {
      content: '{robberyAndTheftPercentage} - '
    }, {
      content: '{robberyAndTheftAmount} '
    }, {
      content: 'Corretora: Viotto Corretora de Seguros e Previdência LTDA. CNPJ: 56.170.061/0001-51 Registro SUSEP: 100059706. Remuneração: 0,03%.'
    }]
  }]
}];
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/FinancialServices/RobberyAndTheft/robbery-theft.data.js
const label = `Pode ficar tranquilo! Nós protegemos por 1 ano os seus equipamentos portáteis contra roubo e furto qualificado e quebra acidental.`;
const include = `Incluir por apenas`;
const includeInstallment = (installmentQuantity, price) => installmentQuantity ? `(${installmentQuantity}x de ${price})` : null;
const includeDesktop = ['incluir Proteção Roubo e Furto', 'qualificado com quebra acidental de 1 ano'];
const includeDesktopLabel = 'Por apenas';
const includeDesktopInstallments = (installmentQuantity, price) => installmentQuantity ? `${installmentQuantity}x de ${price} sem juros` : null;
const includeDesktopPrice = price => `(à vista ${price})`;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-utils/build/esm/currencyFormatter/index.js
var currencyFormatter = __webpack_require__(93837);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(68054);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/FinancialServices/RobberyAndTheft/robbery-theft.styles.js




const Container = styled_components_browser_esm/* default.div */.ZP.div`
  ${props => (0,build_esm/* getMediaQuery */.aK)('large')(props)} {
    display: grid;
    grid-template-columns: 3fr 9fr;
    border-bottom: 1px solid;
    border-color: ${props => (0,build_esm/* getBorderColor */.kJ)('light')(props)};
    padding: 17px 0;
  }
`;
const ServiceOptionsContainer = styled_components_browser_esm/* default.div */.ZP.div`
  ${props => (0,build_esm/* getMediaQuery */.aK)('large')(props)} {
    display: flex;
    align-items: center;
    border-left: 1px solid;
    border-color: ${props => (0,build_esm/* getBorderColor */.kJ)('light')(props)};
    & label svg {
      align-self: flex-start;
    }
  }
`;
const LabelComponent = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)`
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.1')(props)}px;
  line-height: ${props => (0,build_esm/* themeGet */.R)('lineHeights.input')(props)}em;
  margin: 10px 0;

  ${props => (0,build_esm/* getMediaQuery */.aK)('large')(props)} {
    margin: 15px 0 0 0;
  }
`;
const IncludeLabel = styled_components_browser_esm/* default.span */.ZP.span`
  color: ${props => (0,build_esm/* getTextColor */.uu)('base')(props)};
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.1')(props)}px;
  padding-left: 12px;
`;
const IncludeDesktopLabel = (0,styled_components_browser_esm/* default */.ZP)(IncludeLabel)`
  color: ${props => (0,build_esm/* getTextColor */.uu)('primary')(props)};
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.4')(props)}px;
  font-weight: ${props => (0,build_esm/* themeGet */.R)('fontWeights.medium')(props)};
  line-height: ${props => (0,build_esm/* themeGet */.R)('lineHeights.fontSize')(props)};
`;
const LabelContainer = styled_components_browser_esm/* default.div */.ZP.div`
  border-bottom: 1px solid ${props => (0,build_esm/* getPaletteColor */.ow)('border.light')(props)};
  ${index_esm/* space */.Dh}
  &:first-child {
    border-top: 1px solid ${props => (0,build_esm/* getPaletteColor */.ow)('border.light')(props)};
  }

  ${props => (0,build_esm/* getMediaQuery */.aK)('large')(props)} {
    padding: 0 17px;
    border: none;
    &:first-child {
      border: none;
    }
  }
`;
const IncludeDesktopContainer = styled_components_browser_esm/* default.div */.ZP.div`
  display: flex;
  flex-direction: column;

  ${IncludeLabel} {
    margin-bottom: 5px;
  }
`;
const IncludeDesktopHighlight = styled_components_browser_esm/* default.span */.ZP.span`
  color: ${props => (0,build_esm/* getTextColor */.uu)('primary')(props)};
  font-weight: ${props => (0,build_esm/* themeGet */.R)('fontWeights.bold')(props)};
`;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/FinancialServices/RobberyAndTheft/options.js






const Options = ({
  options,
  onChange,
  desktopMode,
  installmentQuantity
}) => {
  const [checkedItems, setCheckedItem] = (0,react.useState)(new Map());

  const handleChange = (e, item) => {
    var _checkedItems$get, _checkedItems$get2;

    onChange(item, ((_checkedItems$get = checkedItems.get(item == null ? void 0 : item.description)) == null ? void 0 : _checkedItems$get.checked) || false);
    const {
      name,
      checked
    } = e.target;

    if ((_checkedItems$get2 = checkedItems.get(item == null ? void 0 : item.description)) != null && _checkedItems$get2.checked) {
      setCheckedItem(prevState => {
        prevState.delete(item == null ? void 0 : item.description);
        return new Map(prevState);
      });
    } else {
      setCheckedItem(prevState => {
        return new Map(prevState).set(name, {
          checked,
          item
        });
      });
    }
  };

  return options.map(item => {
    var _checkedItems$get3;

    return /*#__PURE__*/react.createElement(LabelContainer, {
      key: item == null ? void 0 : item.id,
      p: '12px 0'
    }, /*#__PURE__*/react.createElement(atoms/* Checkbox */.XZ, {
      onChange: e => handleChange(e, item),
      name: item == null ? void 0 : item.description,
      checked: ((_checkedItems$get3 = checkedItems.get(item == null ? void 0 : item.description)) == null ? void 0 : _checkedItems$get3.checked) || false
    }, desktopMode ? /*#__PURE__*/react.createElement(IncludeDesktopContainer, null, /*#__PURE__*/react.createElement(IncludeDesktopLabel, null, includeDesktop[0], /*#__PURE__*/react.createElement("br", null), includeDesktop[1]), /*#__PURE__*/react.createElement("br", null), /*#__PURE__*/react.createElement(IncludeLabel, null, includeDesktopLabel, ' ', /*#__PURE__*/react.createElement(IncludeDesktopHighlight, null, includeDesktopInstallments(installmentQuantity, (0,currencyFormatter/* default */.Z)({
      value: (item == null ? void 0 : item.price) / installmentQuantity
    }))), includeDesktopPrice((0,currencyFormatter/* default */.Z)({
      value: item == null ? void 0 : item.price
    })))) : /*#__PURE__*/react.createElement(IncludeLabel, null, include, ' ', /*#__PURE__*/react.createElement("b", {
      "data-testid": "option-price"
    }, (0,currencyFormatter/* default */.Z)({
      value: item == null ? void 0 : item.price
    })), ' ', /*#__PURE__*/react.createElement("span", {
      "data-testid": "installment-quantity"
    }, includeInstallment(installmentQuantity, (0,currencyFormatter/* default */.Z)({
      value: (item == null ? void 0 : item.price) / installmentQuantity
    })))), /*#__PURE__*/react.createElement("br", null)));
  });
};

Options.defaultProps = {
  options: [],
  onChange: () => ({}),
  desktopMode: false,
  installmentQuantity: null
};
/* harmony default export */ var options = (Options);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Sidebar/index.js + 3 modules
var Sidebar = __webpack_require__(70615);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/FinancialServices/financial-services.styles.js




const SidebarHeader = (0,styled_components_browser_esm/* default */.ZP)(Sidebar/* SidebarHeader */.$)`
  background-color: ${props => (0,build_esm/* getBackgroundColor */.dF)('primary')(props)};
  color: ${props => (0,build_esm/* getTextColor */.uu)('lightest')(props)};
`;
const Wrapper = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Box */.xu)`
  padding: 0 12px;
  max-width: 1366px;
  margin: auto;
`;
const ProductMiniatureContent = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Flex */.kC)`
  align-items: center;
  margin: 10px 0;
`;
const ProductImage = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Image */.Ee)`
  width: 60px;
  height: 60px;
`;
const ProtectProduct = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Heading */.X6)`
  color: ${props => (0,build_esm/* getTextColor */.uu)('scratched')(props)};
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.2')(props)}px;
  line-height: ${props => (0,build_esm/* themeGet */.R)('lineHeights.input')(props)}em;
  margin-left: 5px;
  font-weight: ${props => (0,build_esm/* themeGet */.R)('fontWeights.bold')(props)};
`;
const TitleContent = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Flex */.kC)`
  align-items: center;
  color: ${props => (0,build_esm/* getTextColor */.uu)('base')(props)};
`;
const Description = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Heading */.X6)`
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.2')(props)}px;
  margin-left: 5px;
  font-weight: ${props => (0,build_esm/* themeGet */.R)('fontWeights.bold')(props)};
`;
const Separator = styled_components_browser_esm/* default.div */.ZP.div`
  padding-bottom: 10px;
  margin-bottom: 5px;
`;
const TermItem = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Flex */.kC)`
  padding: 16px 14px;
  justify-content: space-between;
  cursor: pointer;
  p {
    color: ${props => (0,build_esm/* getTextColor */.uu)('base')(props)};
    font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.2')(props)}px;
  }
`;
const RegulationText = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Text */.xv)``;
const ConciseText = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Text */.xv)`
  text-align: center;
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.1')(props)}px;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/FinancialServices/RobberyAndTheft/robbery-theft.js








const RobberyTheft = ({
  service,
  onChange,
  desktopMode,
  installmentQuantity
}) => {
  if (!(service != null && service.offers.length)) return null;
  return /*#__PURE__*/react.createElement(Container, null, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(TitleContent, null, desktopMode ? /*#__PURE__*/react.createElement(esm/* RobberyTheftFull */.ggJ, {
    width: 208,
    height: 59
  }) : /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(esm/* RobberyTheft */.Q4t, {
    "aria-hidden": true
  }), /*#__PURE__*/react.createElement(Description, {
    as: "p",
    mt: '10px'
  }, service == null ? void 0 : service.description))), /*#__PURE__*/react.createElement(LabelComponent, null, label)), /*#__PURE__*/react.createElement(ServiceOptionsContainer, null, /*#__PURE__*/react.createElement(options, {
    options: service == null ? void 0 : service.offers,
    onChange: onChange,
    desktopMode: desktopMode,
    installmentQuantity: installmentQuantity
  })));
};

 false ? 0 : void 0;
RobberyTheft.defaultProps = {
  service: {
    offers: []
  },
  desktopMode: false,
  installmentQuantity: null
};
/* harmony default export */ var robbery_theft = (RobberyTheft);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/FinancialServices/RobberyAndTheft/index.js

;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/FinancialServices/CommonService/common-service.data.js
const common_service_data_ProfitsLabels = [`- Mais tempo de garantia além do fabricante`, `- Consertos utilizando peças genuínas`, `- Mais de 3 mil assistências técnicas em todo o Brasil`, `- Concorra a R$ 5.000,00 durante 3 meses`];
const servicePriceLabel = (service, price) => `${service} por apenas ${price}`;
const installmentLabel = (installmentQuantity, price) => installmentQuantity ? ` (${installmentQuantity}x de ${price})` : '';
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/FinancialServices/CommonService/common-service.styles.js




const common_service_styles_Container = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z)``;
const ProfitLabel = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)`
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.1')(props)}px;
  line-height: ${props => (0,build_esm/* themeGet */.R)('lineHeights.input')(props)}em;
`;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/RadioGroup/index.js + 2 modules
var RadioGroup = __webpack_require__(65055);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/FinancialServices/CommonService/common-service.js








const CommonService = ({
  service,
  onChange,
  Icon,
  defaultOption,
  installmentQuantity
}) => {
  var _service$offers;

  if (!(service != null && service.offers.length)) return null;
  const [selected, setSelected] = (0,react.useState)(defaultOption[0]);

  const handleChange = (e, option) => {
    setSelected(option);
    onChange(e, option);
  };

  const options = service == null ? void 0 : (_service$offers = service.offers) == null ? void 0 : _service$offers.map(item => ({
    id: item == null ? void 0 : item.id,
    value: item == null ? void 0 : item.id,
    price: item == null ? void 0 : item.price,
    label: `${servicePriceLabel(item == null ? void 0 : item.description, (0,currencyFormatter/* default */.Z)({
      value: item == null ? void 0 : item.price
    }))}${installmentLabel(installmentQuantity, (0,currencyFormatter/* default */.Z)({
      value: (item == null ? void 0 : item.price) / installmentQuantity
    }))}`,
    description: item == null ? void 0 : item.description,
    treeId: item == null ? void 0 : item.treeId,
    wageCompensation: item == null ? void 0 : item.wageCompensation
  }));
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(TitleContent, null, /*#__PURE__*/react.createElement(Icon, {
    "aria-hidden": true
  }), /*#__PURE__*/react.createElement(Description, {
    as: "p"
  }, service == null ? void 0 : service.description)), /*#__PURE__*/react.createElement(common_service_styles_Container, {
    mb: '15px',
    mt: '10px'
  }, common_service_data_ProfitsLabels.map((profit, i) => /*#__PURE__*/react.createElement(ProfitLabel, {
    key: `${profit}${i}`
  }, profit))), /*#__PURE__*/react.createElement(common_service_styles_Container, null, /*#__PURE__*/react.createElement(RadioGroup/* default */.Z, {
    options: options.concat(defaultOption),
    selectedOption: selected == null ? void 0 : selected.value,
    onChange: handleChange,
    p: '12px 0'
  })));
};

 false ? 0 : void 0;
CommonService.defaultProps = {
  service: {
    offers: []
  },
  onChange: () => ({}),
  defaultOption: [],
  installmentQuantity: null
};
/* harmony default export */ var common_service = (CommonService);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/FinancialServices/CommonService/index.js

;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/FinancialServices/ExtendedWarranty/extended-warranty.js




const ExtendedWarranty = ({
  service,
  onChange,
  installmentQuantity
}) => {
  const defaultOption = [{
    value: null,
    label: 'Sem garantia estendida, somente garantia do fabricante'
  }];
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(common_service, {
    service: service,
    onChange: onChange,
    defaultOption: defaultOption,
    Icon: esm/* ExtendedWarranty */.Jpv,
    installmentQuantity: installmentQuantity
  }));
};

 false ? 0 : void 0;
ExtendedWarranty.defaultProps = common_service.defaultProps;
/* harmony default export */ var extended_warranty = (ExtendedWarranty);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/FinancialServices/ExtendedWarranty/index.js

;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/FinancialServices/CertainExchange/certain-exchange.js




const CertainExchange = ({
  service,
  onChange,
  installmentQuantity
}) => {
  const defaultOption = [{
    value: null,
    label: 'Sem garantia estendida, somente garantia do fabricante'
  }];
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(common_service, {
    service: service,
    onChange: onChange,
    Icon: esm/* CertainExchange */.Nb3,
    defaultOption: defaultOption,
    installmentQuantity: installmentQuantity
  }));
};

 false ? 0 : void 0;
CertainExchange.defaultProps = common_service.defaultProps;
/* harmony default export */ var certain_exchange = (CertainExchange);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/FinancialServices/CertainExchange/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/index.js + 21 modules
var organisms = __webpack_require__(46514);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/index.js + 18 modules
var utils = __webpack_require__(86349);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/FinancialServices/helpers.js
const isServicesSelected = servicesSelected => {
  return !!Object.values(servicesSelected).find(service => service.length > 0);
};
const filterBySelectedServices = financialServicesSelected => {
  return Object.entries(financialServicesSelected).reduce((acc, [key, value]) => {
    return value.length ? Object.assign({}, acc, {
      [key]: value
    }) : acc;
  }, {});
};
const selectedServicesId = selected => {
  return Object.values(selected).reduce((acc, curr) => acc.concat(curr), []);
};
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/FinancialServices/Term/term.styles.js



const term_styles_Container = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Box */.xu)`
  max-width: 1366px;
  margin: auto;
`;
const term_styles_Title = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Heading */.X6)`
  text-align: center;
  margin: 15px;
  font-weight: ${props => (0,build_esm/* themeGet */.R)('fontWeights.bold')(props)};
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.0')(props)};
`;
const ContentText = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Text */.xv)`
  padding: 5px 0;
  line-height: ${props => (0,build_esm/* themeGet */.R)('lineHeights.input')(props)}em;
`;
const ContentLink = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Text */.xv)`
  text-decoration: underline;
  color: ${props => (0,build_esm/* getTextColor */.uu)('base')(props)};
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/FinancialServices/Term/term.js






const Term = _ref => {
  let {
    terms,
    placeholders = {}
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["terms", "placeholders"]);

  const parseText = text => text && Object.entries(placeholders).reduce((acc, [placeholder, value]) => acc.replace(`{${placeholder}}`, value), text);

  const checkFinancialService = financialService => {
    return Object.entries(placeholders).find(([placeholder, value]) => placeholder.startsWith(financialService) && value);
  };

  return terms.map(term => {
    var _term$content;

    return /*#__PURE__*/react.createElement(term_styles_Container, (0,esm_extends/* default */.Z)({}, props, {
      key: term == null ? void 0 : term.id
    }), /*#__PURE__*/react.createElement(term_styles_Title, {
      as: "p"
    }, parseText(term == null ? void 0 : term.title)), (!(term != null && term.financialService) || checkFinancialService(term.financialService)) && /*#__PURE__*/react.createElement(ContentText, {
      "data-testid": term.id
    }, term == null ? void 0 : (_term$content = term.content) == null ? void 0 : _term$content.map(content => {
      var _content$text;

      return content.link ? /*#__PURE__*/react.createElement(ContentLink, {
        as: "a",
        href: content == null ? void 0 : content.link,
        key: content == null ? void 0 : content.link
      }, parseText(content == null ? void 0 : content.text)) : content == null ? void 0 : (_content$text = content.text) == null ? void 0 : _content$text.map(item => /*#__PURE__*/react.createElement(ContentText, {
        as: "span",
        key: item.content
      }, item != null && item.bold ? /*#__PURE__*/react.createElement("b", null, parseText(item == null ? void 0 : item.content)) : parseText(item == null ? void 0 : item.content)));
    })));
  });
};

 false ? 0 : void 0;
Term.defaultProps = {
  terms: []
};
/* harmony default export */ var Term_term = (Term);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/FinancialServices/Term/index.js

;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/FinancialServices/TermsSidebar/terms-sidebar.js










const TermsSidebar = ({
  servicesSelected,
  showRobberyTerm,
  setShowRobberyTerm,
  showExtendedWarrantyTerm,
  setShowExtendedWarrantyTerm,
  showPaymentsWay,
  setShowPaymentsWay
}) => {
  const terms = [{
    id: 'robbery-theft-terms',
    show: showRobberyTerm,
    terms: RobberyTerms,
    title: 'fechar termos de roubo e furto',
    label: ProtectRobberyAndTheft,
    onClick: () => setShowRobberyTerm(false)
  }, {
    id: 'extended-warranty-terms',
    show: showExtendedWarrantyTerm,
    terms: ExtendedWarrantyTerms,
    title: 'fechar termos de garantia estendida',
    label: ExtendedWarrantyLabel,
    onClick: () => setShowExtendedWarrantyTerm(false)
  }, {
    id: 'payments-way-terms',
    show: showPaymentsWay,
    terms: PaymentsWayTerms,
    title: 'fechar formas de pagamento de serviço',
    label: PaymentsWayLabel,
    onClick: () => setShowPaymentsWay(false)
  }];
  const totalPrice = Object.values(servicesSelected).reduce((acc, selected) => {
    selected.forEach(service => {
      acc += service.price;
    });
    return acc;
  }, 0);
  const totalDescription = Object.values(servicesSelected).reduce((acc, selected) => {
    selected.forEach(service => {
      acc.push(service.description);
    });
    return acc;
  }, []);
  const totalWageCompensation = Object.values(servicesSelected).reduce((acc, selected, index) => {
    const key = Object.keys(servicesSelected)[index];
    selected.forEach(service => {
      var _service$wageCompensa, _service$wageCompensa2;

      Object.assign(acc, {
        [`${key}Amount`]: (_service$wageCompensa = service.wageCompensation) != null && _service$wageCompensa.amount ? (0,currencyFormatter/* default */.Z)({
          value: service.wageCompensation.amount
        }) : null,
        [`${key}Percentage`]: (_service$wageCompensa2 = service.wageCompensation) != null && _service$wageCompensa2.percentage ? `${service.wageCompensation.percentage}%` : null
      });
    });
    return acc;
  }, {});
  return /*#__PURE__*/react.createElement(react.Fragment, null, terms.map(term => {
    return /*#__PURE__*/react.createElement(organisms/* Sidebar */.YE, {
      fullScreen: true,
      direction: "right",
      key: term.id,
      visible: term.show,
      "data-testid": term.id
    }, /*#__PURE__*/react.createElement(SidebarHeader, {
      leftButton: {
        icon: 'back',
        title: term.title,
        iconColor: '#fefefe',
        onClick: term.onClick
      },
      label: term.label
    }), /*#__PURE__*/react.createElement(atoms/* Strip */.D_, null), /*#__PURE__*/react.createElement(Term_term, {
      terms: term.terms,
      placeholders: {
        totalPrice: (0,currencyFormatter/* default */.Z)({
          value: totalPrice
        }),
        description: (0,utils/* parseDescriptionValue */.zY)(totalDescription),
        extendedWarrantyAmount: totalWageCompensation.extendedWarrantyAmount,
        extendedWarrantyPercentage: totalWageCompensation.extendedWarrantyPercentage,
        certainExchangeAmount: totalWageCompensation.certainExchangeAmount,
        certainExchangePercentage: totalWageCompensation.certainExchangePercentage,
        robberyAndTheftAmount: totalWageCompensation.robberyAndTheftAmount,
        robberyAndTheftPercentage: totalWageCompensation.robberyAndTheftPercentage
      },
      p: '0 12px'
    }));
  }));
};

 false ? 0 : void 0;
/* harmony default export */ var terms_sidebar = (TermsSidebar);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/FinancialServices/TermsSidebar/index.js

;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/FinancialServices/financial-services.js
















const FinancialServices = _ref => {
  var _installment$quantity;

  let {
    installment,
    services,
    servicesPriority,
    onContinueClick,
    visible,
    timeTransition,
    onCloseClick,
    protectLabelAs,
    onChange,
    showCloseButton
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["installment", "services", "servicesPriority", "onContinueClick", "visible", "timeTransition", "onCloseClick", "protectLabelAs", "onChange", "showCloseButton"]);

  const RobberyAndTheftId = 'robberyAndTheft';
  const ExtendedWarrantyId = 'extendedWarranty';
  const CertainExchangeId = 'certainExchange';
  const [showRobberyTerm, setShowRobberyTerm] = (0,react.useState)(false);
  const [showExtendedWarrantyTerm, setShowExtendedWarrantyTerm] = (0,react.useState)(false);
  const [showPaymentsWay, setShowPaymentsWay] = (0,react.useState)(false);
  const [servicesSelected, setServiceSelected] = (0,react.useState)({
    [RobberyAndTheftId]: [],
    [ExtendedWarrantyId]: [],
    [CertainExchangeId]: []
  });
  const {
    records
  } = services;
  const installmentQuantity = (_installment$quantity = installment == null ? void 0 : installment.quantity) !== null && _installment$quantity !== void 0 ? _installment$quantity : null;
  const [robberyAndTheft, extendedWarranty, certainExchange] = (0,utils/* sortServices */.yH)(records, servicesPriority);

  const handleRobberyOptionsChange = (item, checked) => {
    const newValue = checked ? servicesSelected[RobberyAndTheftId].filter(serviceItem => (serviceItem == null ? void 0 : serviceItem.id) !== (item == null ? void 0 : item.id)) : servicesSelected[RobberyAndTheftId].concat(item);
    onChange(filterBySelectedServices(Object.assign({}, servicesSelected, {
      [RobberyAndTheftId]: newValue
    })));
    setServiceSelected(Object.assign({}, servicesSelected, {
      [RobberyAndTheftId]: newValue
    }));
  };

  const handleCommonService = (e, item, type) => {
    const newValue = [item];
    onChange(filterBySelectedServices(Object.assign({}, servicesSelected, {
      [type]: (item == null ? void 0 : item.value) === null ? [] : newValue
    })));
    setServiceSelected(Object.assign({}, servicesSelected, {
      [type]: (item == null ? void 0 : item.value) === null ? [] : newValue
    }));
  };

  const handleContinue = () => {
    if (selectedServicesId(servicesSelected).length) {
      onContinueClick(filterBySelectedServices(servicesSelected));
    } else {
      onContinueClick(null);
    }
  };

  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(organisms/* Sidebar */.YE, (0,esm_extends/* default */.Z)({
    visible: visible,
    direction: "right",
    timeTransition: timeTransition,
    fullScreen: true
  }, props), /*#__PURE__*/react.createElement(atoms/* Strip */.D_, null), /*#__PURE__*/react.createElement(SidebarHeader, {
    leftButton: {
      icon: 'close',
      title: 'fechar serviços financeiros',
      onClick: onCloseClick,
      iconColor: '#fefefe'
    },
    label: Title,
    showCloseButton: showCloseButton
  }), /*#__PURE__*/react.createElement(Wrapper, null, /*#__PURE__*/react.createElement(ProductMiniatureContent, null, /*#__PURE__*/react.createElement(ProductImage, {
    src: services.image,
    width: 60,
    height: 60,
    "aria-hidden": true
  }), /*#__PURE__*/react.createElement(ProtectProduct, {
    as: protectLabelAs
  }, ProtectLabel)), /*#__PURE__*/react.createElement(robbery_theft, {
    service: robberyAndTheft,
    "data-testid": "roubo-furto",
    onChange: handleRobberyOptionsChange,
    installmentQuantity: installmentQuantity
  }), /*#__PURE__*/react.createElement(Separator, null), /*#__PURE__*/react.createElement(certain_exchange, {
    service: certainExchange,
    "data-testid": "troca-certa",
    onChange: (e, item) => handleCommonService(e, item, CertainExchangeId),
    installmentQuantity: installmentQuantity
  }), /*#__PURE__*/react.createElement(Separator, null), /*#__PURE__*/react.createElement(extended_warranty, {
    service: extendedWarranty,
    "data-testid": "garantia-estendida",
    onChange: (e, item) => handleCommonService(e, item, ExtendedWarrantyId),
    installmentQuantity: installmentQuantity
  }), /*#__PURE__*/react.createElement(atoms/* Button */.zx, {
    "data-testid": "financial-services-submit",
    m: '10px 0',
    color: "secondary",
    width: '100%',
    fontSize: 1,
    onClick: handleContinue,
    full: true
  }, isServicesSelected(servicesSelected) ? 'Contratar serviço e ir para sacola' : 'Ir para sacola'), /*#__PURE__*/react.createElement(Separator, null), !!selectedServicesId(servicesSelected).length && /*#__PURE__*/react.createElement(ConciseText, null, ConciseMessage, " ", /*#__PURE__*/react.createElement("b", null, Conditions)), /*#__PURE__*/react.createElement(Separator, null), /*#__PURE__*/react.createElement(TermItem, {
    onClick: () => setShowRobberyTerm(true),
    "data-testid": "robbery-theft-term-item"
  }, /*#__PURE__*/react.createElement("p", null, RobberyAndTheftLabel), /*#__PURE__*/react.createElement(esm/* ArrowRight */.olP, {
    width: "12px",
    height: "12px"
  })), /*#__PURE__*/react.createElement(TermItem, {
    onClick: () => setShowExtendedWarrantyTerm(true),
    "data-testid": "extended-warranty-term-item"
  }, /*#__PURE__*/react.createElement("p", null, ExtendedWarrantyLabel), /*#__PURE__*/react.createElement(esm/* ArrowRight */.olP, {
    width: "12px",
    height: "12px"
  })), !!selectedServicesId(servicesSelected).length && /*#__PURE__*/react.createElement(TermItem, {
    onClick: () => setShowPaymentsWay(true),
    "data-testid": "payments-way-term-item"
  }, /*#__PURE__*/react.createElement("p", null, PaymentsWayLabel), /*#__PURE__*/react.createElement(esm/* ArrowRight */.olP, {
    width: "12px",
    height: "12px"
  })), /*#__PURE__*/react.createElement(Separator, null), /*#__PURE__*/react.createElement(RegulationText, {
    fontSize: 0,
    fontWeight: "medium"
  }, ExtendedWarrantyRegulationTitle), /*#__PURE__*/react.createElement(RegulationText, {
    fontSize: 0,
    color: "scratched"
  }, ExtendedWarrantyRegulation), /*#__PURE__*/react.createElement(Separator, null), /*#__PURE__*/react.createElement(RegulationText, {
    fontSize: 0,
    fontWeight: "medium"
  }, RobberyRegulationTitle), /*#__PURE__*/react.createElement(RegulationText, {
    fontSize: 0,
    color: "scratched"
  }, RobberyRegulation))), /*#__PURE__*/react.createElement(terms_sidebar, {
    servicesSelected: servicesSelected,
    showRobberyTerm: showRobberyTerm,
    setShowRobberyTerm: setShowRobberyTerm,
    showExtendedWarrantyTerm: showExtendedWarrantyTerm,
    setShowExtendedWarrantyTerm: setShowExtendedWarrantyTerm,
    showPaymentsWay: showPaymentsWay,
    setShowPaymentsWay: setShowPaymentsWay
  }));
};

 false ? 0 : void 0;
FinancialServices.defaultProps = {
  installment: {
    quantity: null
  },
  services: {
    image: ''
  },
  visible: true,
  timeTransition: 0.3,
  servicesPriority: ServicesPriority,
  protectLabelAs: 'p',
  onContinueClick: () => ({}),
  onCloseClick: () => ({}),
  onChange: () => ({}),
  showCloseButton: true
};
/* harmony default export */ var financial_services = (FinancialServices);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/FinancialServices/index.js


/***/ }),

/***/ 49647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ footer; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Link/index.js + 2 modules
var Link = __webpack_require__(10200);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/Footer/footer.styles.js




const Container = styled_components_browser_esm/* default.footer */.ZP.footer`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.2;
  font-size: 12px;
  font-weight: 400;
  text-align: center;
  overflow: hidden;
  ${esm/* color */.$_}
`;
const Rules = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)`
  padding: 20px 8px;
  ${esm/* color */.$_}
`;
const Policy = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z)`
  text-decoration: underline;
  font-size: unset;
  ${esm/* color */.$_}
`;
const footer_styles_Link = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z)`
  margin: 8px;
  text-decoration: underline;
  font-size: unset;
  ${esm/* color */.$_}
`;
const Address = styled_components_browser_esm/* default.address */.ZP.address`
  padding: 20px 8px;
`;
const Line = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)`
  ${esm/* color */.$_}
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/Footer/footer.js


/* eslint-disable react/no-array-index-key */

/* eslint-disable sonarjs/no-duplicate-string */




/**
 *  This component is the webstore default `mobile` Footer
 */

function Footer(_ref) {
  let {
    footerData,
    strip,
    colors
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["footerData", "strip", "colors"]);

  const {
    rules = '',
    address = [],
    policy = {},
    links = []
  } = footerData;
  return /*#__PURE__*/react.createElement(Container, props, strip && /*#__PURE__*/react.createElement(atoms/* Strip */.D_, null), /*#__PURE__*/react.createElement(Rules, {
    "data-testid": "rules-line",
    color: colors.rules
  }, rules), !!(policy != null && policy.label) && !!(policy != null && policy.link) && /*#__PURE__*/react.createElement(Policy, {
    "data-testid": "policy-line",
    target: "_blank",
    href: policy.link,
    rel: policy == null ? void 0 : policy.rel,
    color: colors.policy
  }, policy.label), !!(links != null && links.length) && links.map(link => /*#__PURE__*/react.createElement(footer_styles_Link, {
    key: link.label,
    "data-testid": "link-line",
    target: "_blank",
    href: link.url,
    rel: link == null ? void 0 : link.rel,
    color: colors.link
  }, link.label)), /*#__PURE__*/react.createElement(Address, null, address.map((item, idx) => /*#__PURE__*/react.createElement(Line, {
    key: idx,
    "data-testid": "address-line",
    color: colors.address
  }, item))));
}

Footer.defaultProps = {
  footerData: {},
  bg: 'background.primary',
  colors: {
    rules: 'text.white',
    policy: 'text.white',
    link: 'text.white',
    address: 'text.white'
  },
  strip: true
};
 false ? 0 : void 0;
/* harmony default export */ var footer = (Footer);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/Footer/index.js


/***/ }),

/***/ 70385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ footer; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/index.js + 33 modules
var molecules = __webpack_require__(39146);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(68054);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/FooterDesktop/footer.styles.js




const MultiColorHorizontalRule = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Strip */.D_)``;
const Container = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs(props => Object.assign({
  bg: 'background.primary'
}, props))`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  ${esm/* color */.$_}
  ${index_esm/* space */.Dh}
`;
Container.ContentWrapper = styled_components_browser_esm/* default.div */.ZP.div`
  width: 100%;
  /* TODO: USE A THEME SETTING HERE */
  max-width: 1312px;
`;
Container.Content = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs(props => Object.assign({
  pt: '4',
  pb: '3'
}, props))`
  background-color: ${(0,esm/* getBackgroundColor */.dF)('primary')};
  ${index_esm/* space */.Dh}
`;
Container.Bottom = styled_components_browser_esm/* default.div */.ZP.div`
  display: flex;
  justify-content: center;
  background-color: ${(0,esm/* getBackgroundColor */.dF)('white')};
  width: 100%;
`;
Container.BottomContent = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs(props => Object.assign({
  maxWidth: '1000px',
  p: '3',
  lineHeight: 'fontSize'
}, props))`
  width: 100%;
  text-align: center;

  ${index_esm/* typography */.cp}
  ${index_esm/* layout */.bK}
  ${index_esm/* space */.Dh}
`;
const PaymentMethods = styled_components_browser_esm/* default.a */.ZP.a`
  display: flex;
  justify-content: center;
  cursor: pointer;
  text-decoration: none;
`;
PaymentMethods.Content = styled_components_browser_esm/* default.div */.ZP.div`
  width: 100%;
  max-width: 990px;
  padding-bottom: 20px;
  border-bottom: 1px solid ${(0,esm/* themeGet */.R)('baseColors.magablu.light')};
`;
PaymentMethods.Title = styled_components_browser_esm/* default.p.attrs */.ZP.p.attrs(props => Object.assign({
  color: 'text.lightest',
  fontSize: 3
}, props))`
  text-align: center;
  margin-bottom: 20px;
  ${esm/* color */.$_}
  ${index_esm/* typography */.cp}
`;
PaymentMethods.MethodsContainer = styled_components_browser_esm/* default.div */.ZP.div`
  display: flex;
  justify-content: center;
`;
PaymentMethods.MethodsContent = styled_components_browser_esm/* default.ul.attrs */.ZP.ul.attrs(props => Object.assign({
  maxWidth: '620px'
}, props))`
  list-style: none;
  display: flex;
  justify-content: space-between;
  width: 100%;
  ${index_esm/* layout */.bK}
`;
PaymentMethods.Method = styled_components_browser_esm/* default.li */.ZP.li`
  width: 35px;
`;
PaymentMethods.MethodImage = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Image */.Ee)``;
const CertificatePartners = styled_components_browser_esm/* default.div */.ZP.div`
  padding: 10px 0;
`;
CertificatePartners.CertificatesContainer = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs(props => Object.assign({
  mb: '3'
}, props))`
  display: flex;
  justify-content: center;
  ${index_esm/* space */.Dh}
`;
CertificatePartners.CertificatesContent = styled_components_browser_esm/* default.ul.attrs */.ZP.ul.attrs(props => Object.assign({
  maxWidth: '990px',
  minWidth: '300px'
}, props))`
  display: flex;
  list-style: none;
  justify-content: space-between;
  align-items: center;
  ${index_esm/* layout */.bK}
  ${index_esm/* typography */.cp}
`;
CertificatePartners.Title = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Link */.rU).attrs(props => Object.assign({
  color: 'text.lightest',
  p: 0
}, props))`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 120px;

  & > *:not(:first-child) {
    margin-left: ${(0,esm/* themeGet */.R)('space.2')}px;
  }
`;
CertificatePartners.TitleLabel = styled_components_browser_esm/* default.span.attrs */.ZP.span.attrs(props => Object.assign({
  color: 'text.lightest',
  fontSize: 0,
  maxWidth: '70px'
}, props))`
  ${index_esm/* layout */.bK}
  ${index_esm/* typography */.cp}
  ${esm/* color */.$_}
`;
const Link = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Link */.rU).attrs(props => Object.assign({
  color: 'text.lightest'
}, props))``;
const SubscriptionForm = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs(props => Object.assign({
  mb: '3'
}, props))`
  display: flex;
  justify-content: center;
  ${index_esm/* space */.Dh}
`;
SubscriptionForm.Content = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs(props => Object.assign({
  maxWidth: '620px'
}, props))`
  width: 100%;
  ${index_esm/* layout */.bK}
`;
const LinksNav = styled_components_browser_esm/* default.div */.ZP.div`
  display: flex;
  justify-content: center;
`;
LinksNav.SectionsList = styled_components_browser_esm/* default.ul.attrs */.ZP.ul.attrs(props => Object.assign({
  maxWidth: '990px'
}, props))`
  display: flex;
  justify-content: space-around;
  list-style: none;
  width: 100%;
  ${index_esm/* layout */.bK}
`;
LinksNav.Column = styled_components_browser_esm/* default.li */.ZP.li``;
LinksNav.SectionTitle = styled_components_browser_esm/* default.p.attrs */.ZP.p.attrs(props => Object.assign({
  color: 'text.lightest',
  fontSize: 1,
  fontWeight: 'regular'
}, props))`
  padding: 10px;
  ${esm/* color */.$_}
  ${index_esm/* typography */.cp}
`;
LinksNav.LinksList = styled_components_browser_esm/* default.ul */.ZP.ul`
  display: inline-flex;
  writing-mode: vertical-lr;
  flex-wrap: wrap;
  align-content: flex-start;
  max-height: 270px;
  line-height: ${(0,esm/* themeGet */.R)('lineHeights.thin')}px;

  ${Link} {
    font-size: ${(0,esm/* themeGet */.R)('fontSizes.0')}px;
    color: ${(0,esm/* themeGet */.R)('colors.lightBlue')};
  }
`;
LinksNav.LinkItem = styled_components_browser_esm/* default.li */.ZP.li`
  list-style: none;
  writing-mode: horizontal-tb;
  padding: 1px 0px;
`;
LinksNav.Content = styled_components_browser_esm/* default.span.attrs */.ZP.span.attrs(props => Object.assign({
  gap: '12px'
}, props))`
  &:not(:first-child) {
    margin-left: ${({
  gap
}) => gap};
  }
`;
LinksNav.Text = styled_components_browser_esm/* default.div */.ZP.div`
  ${index_esm/* layout */.bK}
  ${index_esm/* typography */.cp}
`;
LinksNav.Image = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Image */.Ee).attrs(props => Object.assign({
  maxHeight: '12px'
}, props))`
  width: auto;
`;
const Line = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Text */.xv).attrs(props => Object.assign({
  fontSize: 0
}, props))`
  padding: ${(0,esm/* themeGet */.R)('space.1')}px ${(0,esm/* themeGet */.R)('space.3')}px;
  color: ${(0,esm/* getTextColor */.uu)('light')};
  ${index_esm/* typography */.cp}
  ${esm/* color */.$_}
`;
const InfoLink = styled_components_browser_esm/* default.a */.ZP.a`
  color: ${(0,esm/* getTextColor */.uu)('light')};
`;

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var build_esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/lodash/lodash.js
var lodash = __webpack_require__(76635);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/FooterDesktop/subcomponents/ContactSection/ContactSection.styled.js




const ContactSection_styled_Container = styled_components_browser_esm/* default.div */.ZP.div``;
const textColor = 'text.lightest';
const Content = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs(props => Object.assign({
  color: textColor
}, props))`
  padding: 10px;
  ${esm/* color */.$_}
`;
const Phone = styled_components_browser_esm/* default.p.attrs */.ZP.p.attrs(props => Object.assign({
  fontSize: 5
}, props))`
  margin-bottom: 10px;
  line-height: 24px;
  ${index_esm/* typography */.cp}
`;
const OpeningHours = styled_components_browser_esm/* default.p.attrs */.ZP.p.attrs(props => Object.assign({
  fontSize: 0
}, props))`
  margin-bottom: 10px;
  ${index_esm/* typography */.cp}
`;
const Links = styled_components_browser_esm/* default.ul */.ZP.ul`
  list-style: none;
`;
const LinkItem = styled_components_browser_esm/* default.li */.ZP.li`
  display: flex;
  margin-bottom: 20px;
`;
const ContactSection_styled_Link = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Link */.rU).attrs(props => Object.assign({
  color: textColor,
  pl: 1
}, props))``;
const SectionTitle = styled_components_browser_esm/* default.p.attrs */.ZP.p.attrs(props => Object.assign({
  color: textColor,
  fontSize: 1,
  fontWeight: 'regular'
}, props))`
  padding: 1rem 0 10px 0;
  ${esm/* color */.$_}
  ${index_esm/* typography */.cp}
`;
const SocialLinks = styled_components_browser_esm/* default.ul */.ZP.ul`
  list-style: none;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 0.7rem;
`;
const LinkImage = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Image */.Ee).attrs(props => Object.assign({
  minHeight: '35px'
}, props))`
  width: auto;
`;
const SalesChannels = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs(props => Object.assign({}, props))`
  ${index_esm/* typography */.cp}
  margin-bottom: 10px;
`;
const SaleChannel = styled_components_browser_esm/* default.p.attrs */.ZP.p.attrs(props => Object.assign({
  fontSize: 3,
  color: textColor
}, props))`
  svg {
    margin-right: 2px;
  }
  ${index_esm/* typography */.cp}
  display: flex;
  align-items: center;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/FooterDesktop/subcomponents/ContactSection/ContactSection.js







const ContactSection = ({
  phone,
  salesChannels,
  openingHours,
  accessibility,
  mobileVersion,
  links,
  social
}) => {
  const renderSocial = () => {
    if (!(social != null && social.links)) {
      return null;
    }

    return /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(SectionTitle, null, social.title || 'Siga para mais conteúdo:'), /*#__PURE__*/react.createElement(SocialLinks, null, social.links.map(({
      url,
      img,
      label
    }, socialIndex) => /*#__PURE__*/react.createElement(LinkItem, {
      key: socialIndex
    }, /*#__PURE__*/react.createElement(atoms/* Link */.rU, {
      href: url,
      target: "_blank",
      title: label
    }, /*#__PURE__*/react.createElement(LinkImage, {
      src: img,
      alt: label
    }))))));
  };

  return /*#__PURE__*/react.createElement(ContactSection_styled_Container, null, /*#__PURE__*/react.createElement(Content, null, phone && /*#__PURE__*/react.createElement(Phone, null, phone), /*#__PURE__*/react.createElement(SalesChannels, {
    "data-testid": "sales-channels"
  }, salesChannels == null ? void 0 : salesChannels.map(saleChannel => /*#__PURE__*/react.createElement(SaleChannel, {
    key: lodash_default().uniqueId('salesChannelsContactSection')
  }, saleChannel.icon, /*#__PURE__*/react.createElement("span", null, saleChannel.label)))), /*#__PURE__*/react.createElement(OpeningHours, null, openingHours), /*#__PURE__*/react.createElement(Links, null, links == null ? void 0 : links.map((link, linkIndex) => /*#__PURE__*/react.createElement(LinkItem, {
    key: linkIndex
  }, /*#__PURE__*/react.createElement(ContactSection_styled_Link, {
    href: link.url,
    title: link.title,
    p: 0
  }, link.label))), accessibility && /*#__PURE__*/react.createElement(LinkItem, null, /*#__PURE__*/react.createElement(build_esm/* Accessibility */.yqN, {
    color: "currentColor"
  }), /*#__PURE__*/react.createElement(ContactSection_styled_Link, {
    href: accessibility.url,
    title: accessibility.title
  }, accessibility.label)), mobileVersion && /*#__PURE__*/react.createElement(LinkItem, null, /*#__PURE__*/react.createElement(build_esm/* CategoryTE */.MPk, {
    color: "currentColor"
  }), /*#__PURE__*/react.createElement(ContactSection_styled_Link, {
    href: mobileVersion.url,
    title: mobileVersion.title
  }, mobileVersion.label))), renderSocial()));
};

 false ? 0 : void 0;
/* harmony default export */ var ContactSection_ContactSection = (ContactSection);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/FooterDesktop/subcomponents/ContactSection/index.js

;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/FooterDesktop/subcomponents/index.js

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/FooterDesktop/helpers.js





const renderCertificatePartnersTitle = (_ref = {}, onCertificateClick) => {
  let {
    url,
    title,
    label
  } = _ref,
      otherProps = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["url", "title", "label"]);

  return /*#__PURE__*/react.createElement("li", null, /*#__PURE__*/react.createElement(CertificatePartners.Title, (0,esm_extends/* default */.Z)({
    "data-testid": "certificates-title",
    title: title,
    href: url
  }, otherProps, {
    onClick: e => onCertificateClick(e, {
      url,
      title,
      label
    })
  }), /*#__PURE__*/react.createElement(build_esm/* ServiceHomeSecurity */.$LW, {
    "data-testid": "certificates-title-icon",
    color: "currentColor"
  }), label && /*#__PURE__*/react.createElement(CertificatePartners.TitleLabel, {
    "data-testid": "certificates-title-label"
  }, label)));
};
const renderLinkContent = ({
  url,
  title,
  gap,
  content = [],
  linkAttrs = {}
}, onEventAction = () => {}) => {
  return /*#__PURE__*/react.createElement(Link, (0,esm_extends/* default */.Z)({
    "data-testid": "link-item",
    href: url,
    title: `Link para: ${title}`,
    px: "10px"
  }, linkAttrs), content.map((_ref2, i) => {
    let {
      label,
      img
    } = _ref2,
        styledProps = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, ["label", "img", "iconId"]);

    return /*#__PURE__*/react.createElement(LinksNav.Content, {
      "data-testid": `link-item-children-${i}`,
      key: i,
      gap: gap,
      onClick: e => onEventAction(e, {
        url,
        title
      })
    }, label && /*#__PURE__*/react.createElement(LinksNav.Text, styledProps, label), img && /*#__PURE__*/react.createElement(LinksNav.Image, (0,esm_extends/* default */.Z)({
      src: img,
      alt: title
    }, styledProps)));
  }));
};
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/FooterDesktop/footer.js








function Footer({
  data,
  onSubmitSubscriptionForm,
  onMenuItemClick,
  onPaymentMethodClick,
  onCertificateClick
}) {
  var _paymentMethods$list, _certificatePartners$, _bottomInfo$texts, _bottomInfo$links;

  const {
    paymentMethods = {},
    certificatePartners = {},
    linksColumns = [],
    contactSection = {},
    bottomInfo = {},
    subscriptionForm
  } = data;
  return /*#__PURE__*/react.createElement(Container, {
    "data-testid": "footer-elem"
  }, /*#__PURE__*/react.createElement(Container.ContentWrapper, null, /*#__PURE__*/react.createElement(MultiColorHorizontalRule, {
    size: 5,
    position: "relative"
  }), /*#__PURE__*/react.createElement(Container.Content, null, paymentMethods && /*#__PURE__*/react.createElement(PaymentMethods, {
    "data-testid": "payment-methods-container",
    href: paymentMethods.link
  }, /*#__PURE__*/react.createElement(PaymentMethods.Content, null, /*#__PURE__*/react.createElement(PaymentMethods.Title, null, paymentMethods.label), /*#__PURE__*/react.createElement(PaymentMethods.MethodsContainer, null, /*#__PURE__*/react.createElement(PaymentMethods.MethodsContent, null, (_paymentMethods$list = paymentMethods.list) == null ? void 0 : _paymentMethods$list.map((item, idx) => /*#__PURE__*/react.createElement(PaymentMethods.Method, {
    "data-testid": "payment-option",
    key: idx
  }, /*#__PURE__*/react.createElement(PaymentMethods.MethodImage, {
    onClick: e => onPaymentMethodClick(e, {
      title: item.title
    }),
    src: item.img,
    alt: item.title
  }))))))), /*#__PURE__*/react.createElement(CertificatePartners, null, /*#__PURE__*/react.createElement(CertificatePartners.CertificatesContainer, null, /*#__PURE__*/react.createElement(CertificatePartners.CertificatesContent, null, renderCertificatePartnersTitle(certificatePartners.title, onCertificateClick), certificatePartners == null ? void 0 : (_certificatePartners$ = certificatePartners.certificates) == null ? void 0 : _certificatePartners$.map((item, idx) => {
    return /*#__PURE__*/react.createElement("li", {
      "data-testid": "certificate-partner",
      key: idx
    }, renderLinkContent(item, onCertificateClick));
  }), /*#__PURE__*/react.createElement("li", null, /*#__PURE__*/react.createElement("a", {
    id: "seloEbit",
    href: "http://www.ebit.com.br/552",
    rel: "noreferrer",
    target: "_blank",
    "data-noop": "redir(this.href);"
  })), /*#__PURE__*/react.createElement("li", null, /*#__PURE__*/react.createElement("div", {
    id: "reputation-ra"
  }))))), subscriptionForm && /*#__PURE__*/react.createElement(SubscriptionForm, null, /*#__PURE__*/react.createElement(SubscriptionForm.Content, null, /*#__PURE__*/react.createElement(molecules/* SubscriptionForm */.ok, (0,esm_extends/* default */.Z)({
    onSubmitForm: onSubmitSubscriptionForm
  }, subscriptionForm)))), /*#__PURE__*/react.createElement(LinksNav, null, /*#__PURE__*/react.createElement(LinksNav.SectionsList, null, linksColumns.map((column, colIndex) => /*#__PURE__*/react.createElement(LinksNav.Column, {
    "data-testid": "link-column",
    key: colIndex
  }, column.map((section, sectionIndex) => {
    const linksList = section.links;
    return /*#__PURE__*/react.createElement("div", {
      "data-testid": "link-section",
      key: sectionIndex
    }, /*#__PURE__*/react.createElement(LinksNav.SectionTitle, null, section.title), /*#__PURE__*/react.createElement(LinksNav.LinksList, null, linksList.map((link, idy) => /*#__PURE__*/react.createElement(LinksNav.LinkItem, {
      "data-testid": `link-item-${idy}`,
      key: `${section}-${idy}`,
      onClick: e => onMenuItemClick(e, link, section == null ? void 0 : section.title)
    }, renderLinkContent(link)))));
  }))), contactSection && /*#__PURE__*/react.createElement(LinksNav.Column, {
    "data-testid": "link-column"
  }, /*#__PURE__*/react.createElement(LinksNav.SectionTitle, null, contactSection.label), /*#__PURE__*/react.createElement(ContactSection_ContactSection, contactSection)))))), /*#__PURE__*/react.createElement(Container.Bottom, null, /*#__PURE__*/react.createElement(Container.BottomContent, null, (_bottomInfo$texts = bottomInfo.texts) == null ? void 0 : _bottomInfo$texts.map((item, idx) => /*#__PURE__*/react.createElement(Line, {
    key: idx,
    "data-testid": "bottom-info-text-line"
  }, item)), (_bottomInfo$links = bottomInfo.links) == null ? void 0 : _bottomInfo$links.map((item, idx) => /*#__PURE__*/react.createElement(Line, {
    key: idx,
    "data-testid": "bottom-info-link-line"
  }, item.label, ": ", /*#__PURE__*/react.createElement(InfoLink, {
    href: item.url
  }, item.url))))));
}

const linkProps =  false ? 0 : {};
 false ? 0 : void 0;
Footer.defaultProps = {
  data: {
    certificatePartners: {},
    linksColumns: [],
    contactSection: {},
    bottomInfo: {}
  },
  onMenuItemClick: null,
  onCertificateClick: null,
  onPaymentMethodClick: null
};
/* harmony default export */ var footer = (Footer);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/FooterDesktop/index.js


/***/ }),

/***/ 71782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ header; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/Header/header.styles.js


const Container = styled_components_browser_esm/* default.header */.ZP.header``;
const Content = styled_components_browser_esm/* default.div */.ZP.div`
  background: ${props => (0,build_esm/* themeGet */.R)('palette.background.primary')(props)};
  height: ${props => (0,build_esm/* themeGet */.R)('sizes.header')(props)};
  color: #fff;
  padding: 5px 9px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;

    [id='logo'] {
      margin-top: 5px;
      width: 98px;
      height: 21px;
    }

    [id='button-burger'] {
      width: 22px;
      height: 22px;
    }
  }

  [id='search-container'] {
    margin-bottom: 5px;
  }
`;
/* add this div just to align shoppingbag icon */

const AlignIcon = styled_components_browser_esm/* default.div */.ZP.div`
  > a {
    position: absolute;
    right: 0px;
    top: 50%;
    transform: translateY(-50%);
  }
`;
const Link = styled_components_browser_esm/* default.a */.ZP.a`
  text-decoration: none;
`;
const Search = styled_components_browser_esm/* default.input */.ZP.input`
  width: 100%;
  border: 0px;
  height: 30px;
  background-color: #fff;
  color: #9b9b9b;
  font-size: 16px;
  padding-left: 10px;
  box-sizing: border-box;

  ::-webkit-search-cancel-button {
    background-color: #818181;
    position: relative;
    right: 10px;
  }
`;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/SidebarMenu/index.js + 3 modules
var SidebarMenu = __webpack_require__(1756);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/index.js + 33 modules
var molecules = __webpack_require__(39146);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/index.js + 21 modules
var organisms = __webpack_require__(46514);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/Header/header.js








/**
 * The `<Header />` default component.
 */

function Header({
  isRendered,
  customSidebar,
  onMenuHeaderClick,
  onLogoClick,
  onMenuItemClick,
  onLogout,
  onSearch,
  onShoppingBagClick,
  onTypeChange,
  onHeaderSuggestionLinkClick,
  onSuggestItemClick,
  onProductItemClick,
  onTopTermItemClick,
  onInputClear,
  onInputClose,
  onInputOpen,
  initialValue,
  data,
  linksSuggestions,
  suggestData,
  logoProps,
  sideMenuOpen,
  topTermsData
}) {
  var _headerData$menu, _headerData$logo2, _headerData$logo3, _headerData$shoppingB, _headerData$shoppingB2, _headerData$search;

  const [open, setOpen] = (0,react.useState)(sideMenuOpen);
  const {
    menuData,
    headerData
  } = data;

  const handleMenuHeaderClick = (e, item) => {
    setOpen(false);
    onMenuHeaderClick(e, item);
  };

  const handleMenuItemClick = (e, item, positionLabel) => {
    setOpen(false);
    onMenuItemClick(e, item, positionLabel);
  };

  return /*#__PURE__*/react.createElement(Container, null, /*#__PURE__*/react.createElement(Content, null, /*#__PURE__*/react.createElement("header", null, /*#__PURE__*/react.createElement(molecules/* IconButton */.hU, {
    name: "Burger",
    onClick: () => setOpen(!open)
  }, /*#__PURE__*/react.createElement(esm/* Burger */.OWX, {
    role: "button",
    "aria-label": (headerData == null ? void 0 : (_headerData$menu = headerData.menu) == null ? void 0 : _headerData$menu.ariaLabel) || 'abrir o menu',
    "data-testid": "button-burger",
    id: "button-burger",
    color: "#fff"
  })), /*#__PURE__*/react.createElement(Link, {
    onClick: e => {
      var _headerData$logo;

      return onLogoClick(e, {
        url: (headerData == null ? void 0 : (_headerData$logo = headerData.logo) == null ? void 0 : _headerData$logo.url) || '/'
      });
    },
    href: (headerData == null ? void 0 : (_headerData$logo2 = headerData.logo) == null ? void 0 : _headerData$logo2.url) || '/',
    role: "link",
    "data-testid": "logo",
    "aria-label": (headerData == null ? void 0 : (_headerData$logo3 = headerData.logo) == null ? void 0 : _headerData$logo3.ariaLabel) || 'ir para página inicial'
  }, /*#__PURE__*/react.createElement(atoms/* Logo */.TR, logoProps)), /*#__PURE__*/react.createElement(AlignIcon, null, /*#__PURE__*/react.createElement(Link, {
    href: headerData == null ? void 0 : (_headerData$shoppingB = headerData.shoppingBag) == null ? void 0 : _headerData$shoppingB.url,
    onClick: onShoppingBagClick,
    role: "link",
    "aria-label": (headerData == null ? void 0 : (_headerData$shoppingB2 = headerData.shoppingBag) == null ? void 0 : _headerData$shoppingB2.ariaLabel) || 'ir para sacola'
  }, /*#__PURE__*/react.createElement(esm/* ShoppingBag */.CKR, {
    id: "shoppingBag",
    color: "#fff",
    width: 24,
    height: 24
  })))), /*#__PURE__*/react.createElement(molecules/* SearchInput */.Mj, {
    onSearch: onSearch,
    onInputClear: onInputClear,
    onSuggestItemClick: onSuggestItemClick,
    onProductItemClick: onProductItemClick,
    onTopTermItemClick: onTopTermItemClick,
    onTypeChange: onTypeChange,
    onInputClose: onInputClose,
    onInputOpen: onInputOpen,
    placeholder: headerData == null ? void 0 : (_headerData$search = headerData.search) == null ? void 0 : _headerData$search.placeholder,
    initialValue: initialValue,
    list: suggestData,
    topTerms: topTermsData
  })), /*#__PURE__*/react.createElement(organisms/* HeaderLinks */.f4, {
    isRendered: isRendered,
    data: linksSuggestions,
    onClick: onHeaderSuggestionLinkClick,
    isMobile: true
  }), /*#__PURE__*/react.createElement(atoms/* Strip */.D_, {
    position: "relative"
  }), /*#__PURE__*/react.createElement(organisms/* Sidebar */.YE, {
    visible: open,
    bg: "base",
    onClickOutside: () => setOpen(false)
  }, customSidebar ? /*#__PURE__*/(0,react.cloneElement)(customSidebar, {
    data: menuData == null ? void 0 : menuData.data
  }) : /*#__PURE__*/react.createElement(SidebarMenu/* default */.Z, {
    data: menuData == null ? void 0 : menuData.data,
    onMenuHeaderClick: handleMenuHeaderClick,
    onLogout: onLogout,
    onMenuItemClick: handleMenuItemClick
  })));
}

 false ? 0 : void 0;
Header.defaultProps = {
  customSidebar: undefined,
  suggestData: [],
  initialValue: '',
  logoProps: {},
  data: {
    headerData: {},
    menuData: {
      data: {
        header: {
          label: '',
          url: '',
          helpers: []
        },
        moreInformation: []
      }
    }
  },
  linksSuggestions: {
    links: [],
    title: ''
  },
  isRendered: false,
  sideMenuOpen: false,
  onCollapsedClick: () => {},
  onMenuHeaderClick: () => {},
  onMenuItemClick: () => {},
  onLogoClick: () => {},
  onLogout: () => {},
  onInputClear: () => {},
  onShoppingBagClick: () => {},
  onSuggestItemClick: () => {},
  onProductItemClick: () => {},
  onInputClose: () => {},
  onInputOpen: () => {}
};
/* harmony default export */ var header = (Header);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/Header/index.js


/***/ }),

/***/ 42887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ header; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(68054);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Logo/index.js + 1 modules
var Logo = __webpack_require__(15566);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/index.js + 33 modules
var molecules = __webpack_require__(39146);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/HeaderDesktop/header.styles.js






const HeaderContainer = styled_components_browser_esm/* default.header.attrs */.ZP.header.attrs(props => Object.assign({
  bg: 'background.primary',
  px: 2
}, props))`
  display: flex;
  justify-content: center;
  width: 100%;
  ${build_esm/* color */.$_}
  ${index_esm/* space */.Dh}
`;
const HeaderContent = styled_components_browser_esm/* default.div */.ZP.div`
  width: 100%;
  /* TODO: USE A THEME SETTING HERE */
  max-width: 1366px;
  position: relative;
  display: grid;
  grid-template-columns: 95px 140px 1fr;
  grid-template-areas:
    '. . links'
    'lu logo widgets'
    'lu menus menus'
    'strip strip strip';
`;
const LuContainer = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Link */.rU)`
  grid-area: lu;
  display: flex;
  align-items: flex-end;
  justify-content: center;
`;
const LogoContainer = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Link */.rU).attrs(props => Object.assign({
  mr: 3
}, props))`
  grid-area: logo;
  display: flex;
  align-items: center;
  cursor: pointer;

  /* Fine tuning: this padding aligns the logo with the search bar vertically */
  padding-bottom: 8px;

  ${index_esm/* space */.Dh}
`;
const StyledLogo = (0,styled_components_browser_esm/* default */.ZP)(Logo/* default */.Z).attrs(() => ({
  width: 138,
  height: 30
}))``;
const LinksContainer = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs(props => Object.assign({
  my: 3
}, props))`
  grid-area: links;
  display: flex;
  justify-content: space-between;
  ${index_esm/* space */.Dh}
`;
const WidgetsContainer = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs(props => Object.assign({
  mb: 3
}, props))`
  grid-area: widgets;
  display: flex;
  align-items: center;

  ${index_esm/* space */.Dh}
`;
const SearchInputContainer = styled_components_browser_esm/* default.div */.ZP.div`
  flex-grow: 1;
  margin-top: ${props => props.hasSibling ? '25px;' : '0px;'};
`;
const StyledWishlistCounterButton = (0,styled_components_browser_esm/* default */.ZP)(molecules/* WishlistCounterButton */.Rs).attrs(props => Object.assign({
  backgroundColor: (0,build_esm/* getBackgroundColor */.dF)('primary')(props),
  iconColor: (0,build_esm/* getTextColor */.uu)('white')(props),
  fontColor: (0,build_esm/* getTextColor */.uu)('white')(props),
  counterColor: '#db44a7'
}, props))``;
const StyledShoppingBagButton = (0,styled_components_browser_esm/* default */.ZP)(molecules/* ShoppingBagButton */.kV).attrs(props => Object.assign({
  backgroundColor: (0,build_esm/* getBackgroundColor */.dF)('primary')(props),
  iconColor: (0,build_esm/* getTextColor */.uu)('white')(props),
  fontColor: (0,build_esm/* getTextColor */.uu)('white')(props),
  counterColor: '#58c22e'
}, props))``;
const MenusContainer = styled_components_browser_esm/* default.div */.ZP.div`
  width: 100%;
  grid-area: menus;
`;
const LoggedAreaContainer = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs(props => Object.assign({
  mx: 3
}, props))`
  width: 150px;
  ${index_esm/* space */.Dh}
`;
const ButtonContainer = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Link */.rU).attrs(props => Object.assign({
  mx: 1
}, props))`
  height: 45px;
  width: 60px;
  ${index_esm/* space */.Dh}
`;
const StyledStrip = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Strip */.D_).attrs(props => Object.assign({}, props))`
  grid-area: strip;
`;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/index.js + 21 modules
var organisms = __webpack_require__(46514);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/index.js + 18 modules
var utils = __webpack_require__(86349);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/HeaderDesktop/Zipcode/zipcode.styles.js





const Popper = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Popper */.rD).attrs(props => Object.assign({
  backgroundColor: '#fffce6'
}, props))`
  z-index: ${(0,build_esm/* themeGet */.R)('zIndices.0')};
`;
const Title = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Text */.xv).attrs(props => Object.assign({
  fontSize: 2,
  fontWeight: 'bold',
  lineHeight: 'display',
  mb: 2
}, props))`
  color: ${props => (0,build_esm/* getPaletteColor */.ow)('primary.dark')(props)};

  ${index_esm/* typography */.cp}
`;
const Content = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Text */.xv).attrs(props => Object.assign({
  fontSize: 1,
  lineHeight: 'display'
}, props))`
  color: ${props => (0,build_esm/* getPaletteColor */.ow)('primary.dark')(props)};

  ${index_esm/* typography */.cp}
`;
const Icon = (0,styled_components_browser_esm/* default */.ZP)(esm/* Icon */.JO$).attrs(props => Object.assign({
  fill: 'primary.dark'
}, props))``;
const ZipCodeBtn = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Text */.xv).attrs(props => Object.assign({
  fontSize: 2,
  fontWeight: 'bold',
  justifySelf: 'flex-end',
  mb: 2,
  mt: 3,
  mr: 2
}, props))`
  color: ${props => (0,build_esm/* getPaletteColor */.ow)('primary.dark')(props)};

  cursor: pointer;
`;
const InfoContainer = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Grid */.rj).attrs(props => Object.assign({
  pl: 2
}, props))`
  max-width: 364px;
`;
const SuccessContainer = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Flex */.kC).attrs(props => Object.assign({
  alignItems: 'center',
  gap: 2,
  px: 2,
  py: 3
}, props))`
  color: ${props => (0,build_esm/* getPaletteColor */.ow)('primary.dark')(props)};

  max-width: 384px;
`;
const ClosePopper = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Box */.xu).attrs(props => Object.assign({
  width: 'fit-content'
}, props))`
  align-self: baseline;
  justify-self: end;
`;
const ZipcodeContainer = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs(props => Object.assign({
  ml: 1,
  mr: 3
}, props))`
  width: 200px;
  transition: all 0.2s ease-in-out;
  &:hover:not(:disabled) {
    transform: scale(1.1);
  }
  ${index_esm/* space */.Dh}
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/HeaderDesktop/Zipcode/zipcode.js









function ClosePopupBtn({
  onClick
}) {
  return /*#__PURE__*/react.createElement(ClosePopper, {
    "data-testid": "close-btn",
    onClick: onClick
  }, /*#__PURE__*/react.createElement(Icon, {
    name: "Close",
    width: 24,
    height: 24,
    cursor: "pointer",
    "data-testid": "close"
  }));
}

 false ? 0 : void 0;

const Zipcode = _ref => {
  let {
    onZipCodeClick,
    onClickPopperBtn,
    onClosePopper,
    onHoverZipCode,
    popperDisplay,
    popper
  } = _ref,
      zipcode = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["onZipCodeClick", "onClickPopperBtn", "onClosePopper", "onHoverZipCode", "popperDisplay", "popper"]);

  const parentRef = (0,react.useRef)(null);
  const {
    enabled: popperEnabled,
    info: {
      title: popperTitle,
      content: popperContent,
      buttonLabel: popperBtnLabel
    } = {},
    success: {
      title: popperSuccessTitle,
      content: popperSuccessContent
    } = {}
  } = popper;

  const renderInfoContent = () => {
    return /*#__PURE__*/react.createElement(InfoContainer, {
      "data-testid": "popper-info-container"
    }, /*#__PURE__*/react.createElement(ClosePopupBtn, {
      onClick: onClosePopper
    }), /*#__PURE__*/react.createElement(Title, null, popperTitle), /*#__PURE__*/react.createElement(Content, null, popperContent), /*#__PURE__*/react.createElement(ZipCodeBtn, {
      "data-testid": "popper-btn",
      onClick: onClickPopperBtn
    }, popperBtnLabel));
  };

  const renderSuccessContent = () => /*#__PURE__*/react.createElement(SuccessContainer, {
    "data-testid": "popper-success-container"
  }, /*#__PURE__*/react.createElement(Icon, {
    name: "DoneCircle",
    width: 32,
    height: 32,
    fill: "alert.success.text",
    "data-testid": "DoneCircle"
  }), /*#__PURE__*/react.createElement(atoms/* Box */.xu, null, /*#__PURE__*/react.createElement(Title, null, popperSuccessTitle), /*#__PURE__*/react.createElement(Content, null, popperSuccessContent)), /*#__PURE__*/react.createElement(ClosePopupBtn, {
    onClick: onClosePopper
  }));

  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(ZipcodeContainer, {
    "data-testid": "zipcode-text-container",
    onClick: onZipCodeClick,
    ref: parentRef,
    onMouseEnter: onHoverZipCode
  }, /*#__PURE__*/react.createElement(molecules/* ZipcodeText */.YQ, (0,esm_extends/* default */.Z)({}, zipcode, {
    formatter: utils/* capitalize */.kC
  }))), popperEnabled && /*#__PURE__*/react.createElement(Popper, {
    visible: !!popperDisplay,
    parentRef: parentRef
  }, popperDisplay === 'success' ? renderSuccessContent() : renderInfoContent()));
};

Zipcode.defaultProps = {
  popper: {
    enabled: false
  },
  onHoverZipCode: () => {}
};
 false ? 0 : void 0;
/* harmony default export */ var Zipcode_zipcode = (Zipcode);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/HeaderDesktop/Zipcode/index.js

;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/HeaderDesktop/header.js









const Header = ({
  data,
  searchSuggestions,
  topTermsData,
  isRendered,
  initialValue,
  linksSuggestions,
  logoProps,
  logoLuProps,
  onInputClose,
  onInputOpen,
  onSuggestItemClick,
  onProductItemClick,
  onTopTermItemClick,
  onHeaderSuggestionLinkClick,
  onZipCodeClick,
  onClickPopperBtn,
  popperDisplay,
  onClosePopper,
  onSearch,
  onTypeSearch,
  onLogout,
  onLogoClick,
  onMenuItemClick,
  customLoginMenu,
  onHorizontalLinksClick,
  onHoverZipCode,
  onClickSearchEvent,
  onUnsignedClick,
  onSignedHover,
  onSignedMenuClick,
  onClickWishlist,
  onHoverMenuItem,
  onClickMenuItem
}) => {
  var _headerData$logo, _headerData$logo2, _headerData$logo3, _headerData$logo4, _linksSuggestions$lin, _headerData$search;

  const {
    account,
    headerData,
    companyLinks,
    contactLinks,
    login,
    wishlist,
    bag,
    zipcode
  } = data;

  const handleMenuItemClick = (e, link, selectedSubmenu, menuType) => {
    onMenuItemClick(e, link, selectedSubmenu, menuType);
  };

  return /*#__PURE__*/react.createElement(HeaderContainer, {
    "data-testid": "header-elem"
  }, /*#__PURE__*/react.createElement(HeaderContent, null, /*#__PURE__*/react.createElement(LuContainer, {
    href: (headerData == null ? void 0 : (_headerData$logo = headerData.logo) == null ? void 0 : _headerData$logo.url) || '/',
    role: "link",
    "aria-label": (headerData == null ? void 0 : (_headerData$logo2 = headerData.logo) == null ? void 0 : _headerData$logo2.ariaLabel) || 'ir para página inicial',
    onClick: onLogoClick,
    "data-testid": "logo-lu-magalu"
  }, logoLuProps ? /*#__PURE__*/react.createElement(esm/* GenericImageIcon */.RdR, logoLuProps) : /*#__PURE__*/react.createElement(esm/* LogoMagaluDesktop */.he$, {
    titleAccess: "Logo Lu",
    width: 95,
    height: 113
  })), /*#__PURE__*/react.createElement(LogoContainer, {
    href: (headerData == null ? void 0 : (_headerData$logo3 = headerData.logo) == null ? void 0 : _headerData$logo3.url) || '/',
    role: "link",
    "aria-label": (headerData == null ? void 0 : (_headerData$logo4 = headerData.logo) == null ? void 0 : _headerData$logo4.ariaLabel) || 'ir para página inicial',
    onClick: onLogoClick,
    "data-testid": "logo-magalu"
  }, /*#__PURE__*/react.createElement(StyledLogo, logoProps)), /*#__PURE__*/react.createElement(LinksContainer, null, /*#__PURE__*/react.createElement(molecules/* HorizontalLinks */.pl, {
    data: companyLinks,
    handleHorizontalLinksClick: onHorizontalLinksClick
  }), /*#__PURE__*/react.createElement(molecules/* HorizontalLinks */.pl, {
    data: contactLinks,
    handleHorizontalLinksClick: onHorizontalLinksClick
  })), /*#__PURE__*/react.createElement(WidgetsContainer, null, /*#__PURE__*/react.createElement(SearchInputContainer, {
    hasSibling: (linksSuggestions == null ? void 0 : (_linksSuggestions$lin = linksSuggestions.links) == null ? void 0 : _linksSuggestions$lin.length) > 1
  }, /*#__PURE__*/react.createElement(molecules/* SearchInput */.Mj, {
    initialValue: initialValue,
    onSearch: onSearch,
    onTypeChange: onTypeSearch,
    onSuggestItemClick: onSuggestItemClick,
    onProductItemClick: onProductItemClick,
    onTopTermItemClick: onTopTermItemClick,
    onClickSearchEvent: onClickSearchEvent,
    onInputClose: onInputClose,
    onInputOpen: onInputOpen,
    placeholder: headerData == null ? void 0 : (_headerData$search = headerData.search) == null ? void 0 : _headerData$search.placeholder,
    list: searchSuggestions.terms,
    products: searchSuggestions.products,
    desktopMode: true,
    topTerms: topTermsData,
    onMenuItemClick: handleMenuItemClick
  }), /*#__PURE__*/react.createElement(organisms/* HeaderLinks */.f4, {
    isRendered: isRendered,
    data: linksSuggestions,
    onClick: onHeaderSuggestionLinkClick
  })), /*#__PURE__*/react.createElement(LoggedAreaContainer, null, customLoginMenu ? /*#__PURE__*/react.createElement(react.Fragment, null, customLoginMenu) : /*#__PURE__*/react.createElement(molecules/* LoginMenu */.RG, (0,esm_extends/* default */.Z)({}, login, account, {
    onLogout: onLogout,
    onUnsignedClick: onUnsignedClick,
    onSignedHover: onSignedHover,
    onSignedMenuClick: onSignedMenuClick
  }))), (zipcode == null ? void 0 : zipcode.showZipcode) && /*#__PURE__*/react.createElement(Zipcode_zipcode, (0,esm_extends/* default */.Z)({}, zipcode, {
    popperDisplay: popperDisplay,
    onZipCodeClick: onZipCodeClick,
    onClickPopperBtn: onClickPopperBtn,
    onClosePopper: onClosePopper,
    onHoverZipCode: onHoverZipCode
  })), (wishlist == null ? void 0 : wishlist.href) && /*#__PURE__*/react.createElement(ButtonContainer, {
    href: wishlist == null ? void 0 : wishlist.href,
    "data-testid": "wishlist-button-container",
    onClick: onClickWishlist
  }, /*#__PURE__*/react.createElement(StyledWishlistCounterButton, (0,esm_extends/* default */.Z)({
    truncateAmountThreshold: 99
  }, wishlist))), /*#__PURE__*/react.createElement(ButtonContainer, {
    href: bag == null ? void 0 : bag.href,
    "data-testid": "bag-button-container"
  }, /*#__PURE__*/react.createElement(StyledShoppingBagButton, (0,esm_extends/* default */.Z)({
    truncateAmountThreshold: 99
  }, bag)))), /*#__PURE__*/react.createElement(MenusContainer, null, /*#__PURE__*/react.createElement(organisms/* LinksMenu */.DH, {
    data: data,
    onMenuItemClick: handleMenuItemClick,
    onHoverMenuItem: onHoverMenuItem,
    onClickMenuItem: onClickMenuItem
  })), /*#__PURE__*/react.createElement(StyledStrip, {
    size: 5,
    position: "relative"
  })));
};

Header.defaultProps = {
  customLoginMenu: null,
  data: {
    account: {},
    headerData: {},
    companyLinks: {},
    contactLinks: {},
    categoryList: {},
    specialLinks: [],
    externalLinks: [],
    allCategories: {},
    login: {},
    wishlist: {},
    bag: {}
  },
  searchSuggestions: {
    terms: [],
    products: []
  },
  linksSuggestions: {
    links: [],
    title: ''
  },
  logoProps: {},
  isRendered: prop_types.bool,
  initialValue: '',
  onInputClose: () => {},
  onInputOpen: () => {},
  onLogout: () => {},
  onSuggestItemClick: () => {},
  onProductItemClick: () => {},
  onTopTermItemClick: () => {},
  onZipCodeClick: () => {},
  onMenuItemClick: () => {},
  onHoverZipCode: () => {},
  onClickWishlist: () => {},
  onHorizontalLinksClick: () => {},
  onUnsignedClick: () => {},
  onSignedHover: () => {},
  onSignedMenuClick: () => {},
  onClickSearchEvent: () => {},
  onHeaderSuggestionLinkClick: () => {},
  onHoverMenuItem: () => {},
  onClickMenuItem: () => {}
};
 false ? 0 : void 0;
/* harmony default export */ var header = (Header);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/HeaderDesktop/index.js


/***/ }),

/***/ 95949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "fh": function() { return /* reexport */ LuContent_LuContentContext; },
  "X6": function() { return /* reexport */ LuDetail_LuDetail; },
  "ZP": function() { return /* reexport */ LuContent_LuContent; }
});

// UNUSED EXPORTS: LuContentHeader

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Dialog/index.js + 1 modules
var Dialog = __webpack_require__(66762);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Sidebar/index.js + 3 modules
var Sidebar = __webpack_require__(70615);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/LuContent/LuContentContext.js


const Context = /*#__PURE__*/(0,react.createContext)();

const LuContentContext = _ref => {
  let {
    children
  } = _ref,
      values = Object.assign({}, _ref.value);
  return /*#__PURE__*/react.createElement(Context.Provider, {
    value: Object.assign({}, values)
  }, children);
};

const useLuContentContext = () => (0,react.useContext)(Context);
 false ? 0 : void 0;
/* harmony default export */ var LuContent_LuContentContext = (LuContentContext);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(68054);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/ResponsiveImage/index.js + 2 modules
var ResponsiveImage = __webpack_require__(7029);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/LuContent/LuContentFooter/LuContentFooter.styles.js




const Container = styled_components_browser_esm/* default.footer */.ZP.footer`
  background-color: ${props => (0,build_esm/* getBackgroundColor */.dF)('luContentPrimary')(props)};
`;
const Text = styled_components_browser_esm/* default.p */.ZP.p`
  color: ${props => (0,build_esm/* getTextColor */.uu)('lightest')(props)};
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.0')(props)}px;
  text-align: center;
  padding-top: 12px;
`;
const LinkWrapper = styled_components_browser_esm/* default.div */.ZP.div``;
const Link = styled_components_browser_esm/* default.a */.ZP.a`
  cursor: pointer;
`;
const LogosContainer = styled_components_browser_esm/* default.div */.ZP.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
  padding: 16px 2em;
`;
const BlogLuImage = (0,styled_components_browser_esm/* default */.ZP)(ResponsiveImage/* default */.Z)`
  max-width: 109px;
  max-height: 20px;
`;
const FacebookIcon = (0,styled_components_browser_esm/* default */.ZP)(esm/* Facebook */.s1S).attrs(props => ({
  color: (0,build_esm/* getBackgroundColor */.dF)('luContentPrimary')(props)
}))``;
const TwitterIcon = (0,styled_components_browser_esm/* default */.ZP)(esm/* Twitter */.tLe).attrs(props => ({
  color: (0,build_esm/* getBackgroundColor */.dF)('luContentPrimary')(props)
}))``;
const InstagramIcon = (0,styled_components_browser_esm/* default */.ZP)(esm/* Instagram */.mre).attrs(props => ({
  color: (0,build_esm/* getBackgroundColor */.dF)('luContentPrimary')(props)
}))``;
const PinterestIcon = (0,styled_components_browser_esm/* default */.ZP)(esm/* Pinterest */.nzZ).attrs(props => ({
  color: (0,build_esm/* getBackgroundColor */.dF)('luContentPrimary')(props)
}))``;
const Circle = styled_components_browser_esm/* default.div */.ZP.div`
  background-color: ${props => (0,build_esm/* getBackgroundColor */.dF)('base')(props)};
  width: 20px;
  height: 20px;
  border-radius: 50%;

  display: flex;
  justify-content: center;
  align-items: center;

  > svg {
    width: 12px;
  }
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/LuContent/LuContentFooter/LuContentFooter.data.js
const LuFrom = `Lu do Magalu`;
const SocialMedia = `nas redes sociais`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/LuContent/LuContentFooter/LuContentFooter.js







const LuContentFooter = _ref => {
  let {
    onBlogClick,
    onSocialMediaClick
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["onBlogClick", "onSocialMediaClick"]);

  const {
    images: {
      blogImage
    } = {},
    links: {
      blog,
      facebook,
      twitter,
      instagram,
      pinterest
    }
  } = useLuContentContext();
  const items = [{
    id: 'facebook',
    icon: FacebookIcon,
    link: facebook
  }, {
    id: 'twitter',
    icon: TwitterIcon,
    link: twitter
  }, {
    id: 'instagram',
    icon: InstagramIcon,
    link: instagram
  }, {
    id: 'pinterest',
    icon: PinterestIcon,
    link: pinterest
  }];
  return /*#__PURE__*/react.createElement(Container, props, /*#__PURE__*/react.createElement(Text, null, /*#__PURE__*/react.createElement("strong", null, LuFrom), " ", SocialMedia, " ", ''), /*#__PURE__*/react.createElement(LogosContainer, null, blogImage && /*#__PURE__*/react.createElement(LinkWrapper, {
    onClick: onBlogClick
  }, /*#__PURE__*/react.createElement(Link, {
    href: blog
  }, /*#__PURE__*/react.createElement(BlogLuImage, {
    src: blogImage,
    alt: "Blog da Lu",
    lazy: true
  }))), /*#__PURE__*/react.createElement(react.Fragment, null, items.filter(({
    link
  }) => Boolean(link)).map(({
    icon: Icon,
    link,
    id
  }) => {
    return /*#__PURE__*/react.createElement(LinkWrapper, {
      key: id
    }, /*#__PURE__*/react.createElement(Link, {
      "data-testid": "social-links",
      href: link,
      onClick: e => onSocialMediaClick(e, {
        id,
        link
      })
    }, /*#__PURE__*/react.createElement(Circle, null, /*#__PURE__*/react.createElement(Icon, {
      titleAccess: `${id} logo`
    }))));
  }))));
};

LuContentFooter.defaultProps = {
  blogImage: '',
  blogLabel: 'Blog da Lu',
  onBlogClick: () => {},
  onSocialMediaClick: () => {}
};
 false ? 0 : void 0;
/* harmony default export */ var LuContentFooter_LuContentFooter = (LuContentFooter);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/LuContent/LuContentFooter/index.js

;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/LuContent/LuContentHeader/LuContentHeader.styles.js






const RoundedTop = styled_components_browser_esm/* css */.iv`
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;

  ${(0,build_esm/* getMediaQuery */.aK)('medium')} {
    border-radius: 4px;
  }
`;
const LuContentHeader_styles_Container = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Grid */.rj).attrs(() => ({
  bg: 'background.luContentPrimary',
  w: 1
}))`
  min-height: 83px;
  ${props => !props.showBackButton && !props.borderRadius && RoundedTop}
  grid-template-columns: 1fr 4fr 1fr;

  ${(0,build_esm/* getMediaQuery */.aK)('medium')} {
    display: flex;
    align-items: center;
    min-height: 80px;
  }

  ${index_esm/* border */.Cg}
  ${index_esm/* borderRadius */.E0}
`;
const ArrowBackContainer = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Box */.xu)`
  margin-top: 14px;
  margin-left: 10px;

  ${(0,build_esm/* getMediaQuery */.aK)('large')} {
    margin-top: 0;
  }
`;
const Content = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Flex */.kC).attrs(() => ({
  pl: [null, null, null, 3]
}))`
  ${(0,build_esm/* getMediaQuery */.aK)('small')} {
    align-items: flex-end;
    align-self: flex-end;
    width: 100%;
  }
`;
const LuContentSocialMedias = (0,styled_components_browser_esm/* default */.ZP)(LuContentFooter_LuContentFooter)`
  ${(0,build_esm/* getMediaQuery */.aK)('medium')} {
    margin: 1em ${(0,build_esm/* themeGet */.R)('space.3')}px 1em auto;
    min-width: 269px;

    > p {
      display: none;
    }

    > div {
      padding: unset;
    }
  }
`;
const LuImage = (0,styled_components_browser_esm/* default */.ZP)(ResponsiveImage/* default */.Z)`
  width: 75px;
  max-height: 87px;
  margin-top: -5px;
`;
const LuExplainContent = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Flex */.kC).attrs({
  flexDirection: 'column',
  justifyContent: 'center',
  ml: '10px'
})`
  ${(0,build_esm/* getMediaQuery */.aK)('medium')} {
    align-self: center;
  }
`;
const LogoLuExplain = (0,styled_components_browser_esm/* default */.ZP)(ResponsiveImage/* default */.Z)`
  ${(0,build_esm/* getMediaQuery */.aK)('medium')} {
    height: 32px;
    width: auto;
  }
`;
const Title = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Text */.xv).attrs(() => ({
  color: 'text.lightest',
  fontWeight: 'bold',
  fontSize: 3,
  lineHeight: 'display',
  forwardedAs: 'h2'
}))`
  text-align: center;
  margin-top: 8px;

  ${props => props.tiny && styled_components_browser_esm/* css */.iv`
      font-size: ${(0,build_esm/* themeGet */.R)('fontSizes.0')(props)}px;
      text-align: left;
      width: 190px;
      ${(0,build_esm/* getMediaQuery */.aK)('medium')} {
        font-size: ${(0,build_esm/* themeGet */.R)('fontSizes.2')(props)}px;
        width: 100%;
      }
    `}
`;
const LinkMoreContent = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Link */.rU).attrs(() => ({
  color: 'text.lightest',
  fontSize: 0
}))`
  margin-top: 10px;
  text-decoration: underline;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/LuContent/LuContentHeader/LuContentHeader.js








const LuContentHeader = _ref => {
  let {
    title,
    subtitle,
    showBackButton,
    onBackButtonClick,
    linkToMoreContentLabel,
    showLinkToMoreContent,
    showSocialMedias,
    onSocialMediaClick,
    iconName
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["title", "subtitle", "showBackButton", "onBackButtonClick", "linkToMoreContentLabel", "showLinkToMoreContent", "showSocialMedias", "onSocialMediaClick", "iconName"]);

  const titleText = subtitle || title;
  const {
    images: {
      luImage,
      luExplainImage
    } = {},
    linkToMoreContent
  } = useLuContentContext() || {};
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(LuContentHeader_styles_Container, (0,esm_extends/* default */.Z)({
    showBackButton: showBackButton,
    "data-testid": "lu-explain-header-container"
  }, props), /*#__PURE__*/react.createElement(ArrowBackContainer, null, showBackButton && /*#__PURE__*/react.createElement(esm/* Icon */.JO$, {
    name: iconName,
    color: "#ffffff",
    "data-testid": "lu-header-close",
    role: "button",
    title: "Voltar",
    tabIndex: "1",
    onClick: onBackButtonClick,
    cursor: "pointer"
  })), /*#__PURE__*/react.createElement(Content, null, /*#__PURE__*/react.createElement(LuImage, {
    src: luImage,
    alt: "personagem Lu do magazineluiza apontando para o logo lu explica",
    width: 60,
    height: 80,
    lazy: true
  }), /*#__PURE__*/react.createElement(LuExplainContent, null, /*#__PURE__*/react.createElement(LogoLuExplain, {
    src: luExplainImage,
    alt: "Lu Explica",
    width: 127,
    height: 24,
    lazy: true
  }), titleText && /*#__PURE__*/react.createElement(Title, {
    tiny: !!subtitle
  }, titleText), showLinkToMoreContent && /*#__PURE__*/react.createElement(LinkMoreContent, {
    "data-testid": "lu-explain-more-content",
    href: linkToMoreContent
  }, linkToMoreContentLabel)), showSocialMedias && /*#__PURE__*/react.createElement(LuContentSocialMedias, {
    onSocialMediaClick: onSocialMediaClick
  }))));
};

LuContentHeader.defaultProps = {
  title: '',
  subtitle: null,
  showBackButton: false,
  onBackButtonClick: () => {},
  linkToMoreContentLabel: '+ Veja outros conteúdos',
  showLinkToMoreContent: false,
  showSocialMedias: false,
  onSocialMediaClick: () => {},
  iconName: 'ArrowBack'
};
 false ? 0 : void 0;
/* harmony default export */ var LuContentHeader_LuContentHeader = (LuContentHeader);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/LuContent/LuContentHeader/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/LuContent/LuDetail/LuDetail.styles.js



const LuDetail_styles_Content = Box/* default */.Z;
const LuDetailContent = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z)`
  padding: 0 14px 14px 14px;
  img {
    width: 100% !important;
    height: auto !important;
  }
  p {
    margin-block-start: 1em;
    margin-block-end: 1em;
    line-height: 20px;
  }
  a {
    color: ${props => (0,build_esm/* getTextColor */.uu)('primary')(props)};
    text-decoration: none;
  }
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/LuContent/LuDetail/LuDetail.js








const Wrapper = ({
  children,
  title,
  visible,
  onBackButtonClick,
  direction
}) => direction === 'center' ? /*#__PURE__*/react.createElement(Dialog/* default */.Z, {
  title: title,
  visible: visible,
  onClickOutside: onBackButtonClick,
  position: "center",
  p: "unset",
  my: "4em"
}, /*#__PURE__*/react.createElement("div", {
  style: {
    width: '100%'
  }
}, children)) : /*#__PURE__*/react.createElement(Sidebar/* default */.Z, {
  direction: direction,
  title: title,
  visible: visible,
  onClickOutside: onBackButtonClick,
  fullScreen: true
}, children);

const LuDetail = ({
  direction,
  title,
  subtitle,
  content,
  onBackButtonClick,
  images,
  visible,
  iconHeaderClose
}) => {
  return /*#__PURE__*/react.createElement(LuContent_LuContentContext, {
    value: {
      images
    }
  }, /*#__PURE__*/react.createElement(Wrapper, {
    direction: direction,
    title: title,
    visible: visible,
    onBackButtonClick: onBackButtonClick
  }, /*#__PURE__*/react.createElement(LuContentHeader_LuContentHeader, {
    title: title,
    subtitle: subtitle,
    showBackButton: true,
    onBackButtonClick: onBackButtonClick,
    iconName: iconHeaderClose
  }), /*#__PURE__*/react.createElement(LuDetailContent, {
    "data-testid": "lu-detail-content"
  }, /*#__PURE__*/react.createElement(LuDetail_styles_Content, {
    dangerouslySetInnerHTML: {
      __html: content
    }
  }))));
};

LuDetail.defaultProps = {
  direction: 'right',
  content: '',
  images: {},
  onBackButtonClick: () => {},
  subtitle: null,
  title: '',
  visible: false,
  iconHeaderClose: 'ArrowBack'
};
 false ? 0 : void 0;
 false ? 0 : void 0;
/* harmony default export */ var LuDetail_LuDetail = (LuDetail);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/LuContent/LuDetail/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/LuContent/LuContent.styles.js


const LuContent_styles_Container = styled_components_browser_esm/* default.div */.ZP.div`
  ${({
  isVerticalView
}) => isVerticalView && styled_components_browser_esm/* css */.iv`
      margin: 36px 8px 20px;
      box-shadow: rgb(0 0 0 / 11%) 0px 1px 10px 0px;
    `}
`;
const ListContentContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs(props => Object.assign({
  bg: 'background.white'
}, props))``;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/index.js + 33 modules
var molecules = __webpack_require__(39146);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var atoms_Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Heading/index.js + 1 modules
var Heading = __webpack_require__(25610);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/LuContent/LuContentItem/LuContentItem.styles.js






const wrapperMarginRight = 28;
const LuContentItem_styles_Wrapper = styled_components_browser_esm/* default.a */.ZP.a`
  text-decoration: none;
  cursor: pointer;
  ${props => props.hide && 'display: none;'}
  ${(0,build_esm/* getMediaQuery */.aK)('medium')} {
    width: calc(25% - ${wrapperMarginRight / 4}px);
    &:not(:last-child) {
      margin-right: ${wrapperMarginRight}px;
    }
  }
`;
const LuContentItem_styles_Content = styled_components_browser_esm/* default.article */.ZP.article`
  background-color: ${props => (0,build_esm/* getBackgroundColor */.dF)('lighter')(props)};
  border-top: 1px solid ${props => (0,build_esm/* getBackgroundColor */.dF)('darker')(props)};
  display: grid;
  padding: 16px;
  width: 100%;
  ${({
  vertical
}) => !vertical && `grid-template-columns: auto 1fr;`}
  ${({
  vertical
}) => vertical && styled_components_browser_esm/* css */.iv`
      justify-items: left;
      padding: 16px 0px;
    `}
`;
const ImageContainer = styled_components_browser_esm/* default.div */.ZP.div`
  width: 100%;
  ${({
  vertical
}) => !vertical && `margin-right: 20px;`}
`;
const ImageItem = (0,styled_components_browser_esm/* default */.ZP)(ResponsiveImage/* default */.Z)`
  width: 77px;
  border-radius: 4px;
  border: 1px solid ${props => (0,build_esm/* getTextColor */.uu)('lighter')(props)};

  ${({
  cover
}) => cover && styled_components_browser_esm/* css */.iv`
      object-fit: cover;
      height: 77px;
    `}

  ${({
  vertical
}) => vertical && styled_components_browser_esm/* css */.iv`
      min-width: 300px;
      width: 100%;
      height: auto;
      max-height: 500px;
      object-fit: fill;

      ${(0,build_esm/* getMediaQuery */.aK)('medium')} {
        max-height: 500px;
        min-height: 168px;
        min-width: 224px;
        height: calc(
          900px /
            ${({
  variation,
  itemsSize
}) => variation === 'horizontal-highlight' ? itemsSize : 4}
        );
        border-radius: 8px;
        object-fit: cover;
      }
    `}
`;
const ArticleContentVertical = styled_components_browser_esm/* css */.iv`
  margin-top: 10px;
  width: 250px;

  ${(0,build_esm/* getMediaQuery */.aK)('large')} {
    max-width: 224px;
  }
`;
const ArticleContent = styled_components_browser_esm/* default.div */.ZP.div`
  display: grid;
  grid-template-columns: auto 1fr;
  margin-top: ${({
  cover
}) => cover ? '8px' : '0px'};
  ${({
  vertical
}) => vertical && ArticleContentVertical}
`;
const TextContainer = styled_components_browser_esm/* default.div */.ZP.div``;
const LuContentItem_styles_Title = (0,styled_components_browser_esm/* default */.ZP)(Heading/* default */.Z).attrs(() => ({
  fontSize: [1, 1, 3, 3]
}))`
  color: ${props => (0,build_esm/* getTextColor */.uu)('luContentLink')(props)};
  font-weight: ${props => (0,build_esm/* themeGet */.R)('fontWeights.medium')(props)};
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
`;
const Description = (0,styled_components_browser_esm/* default */.ZP)(atoms_Text/* default */.Z).attrs(() => ({
  fontSize: [0, 0, 1, 1]
}))`
  margin-top: 8px;
  color: ${props => (0,build_esm/* getTextColor */.uu)('base')(props)};
  line-height: ${props => (0,build_esm/* themeGet */.R)('lineHeights.plus')(props)}px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  ${index_esm/* typography */.cp}
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/LuContent/LuContentItem/LuContentItem.js





const IconByType = {
  article: 'Blog',
  video: 'Video',
  podcast: 'Podcast'
};

const LuContentItem = ({
  data,
  cover,
  vertical,
  hide,
  onItemClick,
  onSubItemClick,
  dataTestId,
  itemsSize,
  variation
}) => {
  const {
    type = 'article',
    title,
    subtitle,
    category,
    subcategory,
    image,
    url,
    urlPostSubcategory
  } = data;
  if (!title || !subtitle) return /*#__PURE__*/react.createElement(react.Fragment, null);
  const IconName = IconByType[type] || 'Blog';
  return /*#__PURE__*/react.createElement(LuContentItem_styles_Wrapper, {
    role: "button",
    href: url,
    target: url && '_blank',
    "data-testid": dataTestId || 'lu-item',
    onClick: e => onItemClick(e, data),
    "aria-label": `Abre o conteúdo do post ${title}`,
    hide: hide
  }, /*#__PURE__*/react.createElement(LuContentItem_styles_Content, {
    "data-testid": "lu-item-content",
    vertical: vertical
  }, /*#__PURE__*/react.createElement(ImageContainer, {
    vertical: vertical
  }, /*#__PURE__*/react.createElement(ImageItem, {
    src: image,
    alt: title,
    vertical: vertical,
    cover: cover,
    itemsSize: itemsSize,
    variation: variation,
    lazy: true
  })), /*#__PURE__*/react.createElement(ArticleContent, {
    vertical: vertical,
    cover: cover,
    "data-testid": "article-content"
  }, /*#__PURE__*/react.createElement(esm/* Icon */.JO$, {
    title: `logo ${type}`,
    name: IconName
  }), /*#__PURE__*/react.createElement(TextContainer, null, /*#__PURE__*/react.createElement(LuContentItem_styles_Title, {
    as: "h3"
  }, title), /*#__PURE__*/react.createElement(Description, null, subtitle), category && subcategory && /*#__PURE__*/react.createElement(atoms/* Link */.rU, {
    p: "8px 0",
    color: "text.base",
    fontWeight: "bold",
    onClick: e => onSubItemClick(e, category, subcategory),
    href: urlPostSubcategory
  }, subcategory.title)))));
};

LuContentItem.defaultProps = {
  data: {},
  vertical: false,
  cover: null,
  onItemClick: () => {},
  onSubItemClick: () => {},
  hide: false,
  dataTestId: '',
  itemsSize: 1
};
 false ? 0 : void 0;
/* harmony default export */ var LuContentItem_LuContentItem = (LuContentItem);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/LuContent/LuContentItem/index.js

;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/LuContent/helpers.js
/**
 * reduce to single array with parent and item index
 * @param {*} list - array with 3 arrays inside
 */
const reduceToSingleArray = (list = []) => {
  if (!Array.isArray(list) || list.length === 0) return [];
  return list.reduce((acc, arr = [], parentIdx) => [...acc, ...arr.map((item, idx) => Object.assign({}, item, {
    parentIdx,
    idx
  }))], []);
};
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/LuContent/variations/CarouselContent.js







const CarouselContent = ({
  onItemClick
}) => {
  const [selected, setSelected] = react.useState(0);
  const {
    data
  } = useLuContentContext();
  const bigArray = reduceToSingleArray(data);
  const topItems = bigArray.filter(item => item.idx === 0);
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(molecules/* Carousel */.lr, {
    bg: "background.lighter",
    slidesPerView: 1,
    showPartial: true,
    transitionDuration: 700,
    auto: false,
    showControls: false,
    gutter: 16,
    onChange: active => setSelected(active)
  }, topItems.map(item => /*#__PURE__*/react.createElement(LuContentItem_LuContentItem, {
    key: item.id,
    vertical: true,
    data: item,
    onItemClick: onItemClick
  }))), bigArray.filter(item => item.idx !== 0).map(item => {
    const hidden = item.parentIdx !== selected;
    return /*#__PURE__*/react.createElement(LuContentItem_LuContentItem, {
      key: item.id,
      data: item,
      hide: hidden,
      dataTestId: hidden ? 'item-hidden' : '',
      cover: true,
      onItemClick: onItemClick
    });
  }));
};

 false ? 0 : void 0;
/* harmony default export */ var variations_CarouselContent = (CarouselContent);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Button/index.js + 2 modules
var Button = __webpack_require__(60861);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/LuContent/variations/HorizontalHighlightContent.js










const BlogLuHorizontalHighlightContent = ({
  onItemClick,
  onLoadMoreClick
}) => {
  const {
    data,
    linkToMoreContent
  } = useLuContentContext();
  const mergedArray = reduceToSingleArray(data);
  const highlightItems = mergedArray.filter(item => item.idx === 0);
  const contentItems = mergedArray.filter(item => item.idx !== 0);

  const getContentItems = highlightedItem => {
    return contentItems.filter(item => item.parentIdx === highlightedItem.parentIdx);
  };

  return /*#__PURE__*/react.createElement(Box/* default */.Z, {
    bg: "background.lighter"
  }, /*#__PURE__*/react.createElement(ListContentContainer, {
    itemsSize: highlightItems.length,
    padding: "0 10px"
  }, highlightItems.map((itemHighlight, itemIndex) => /*#__PURE__*/react.createElement(Box/* default */.Z, {
    key: itemHighlight.id,
    marginRight: highlightItems.length - 1 === itemIndex ? '0px' : '28px',
    width: "100%"
  }, /*#__PURE__*/react.createElement(LuContentItem_LuContentItem, {
    vertical: true,
    itemsSize: highlightItems.length,
    data: itemHighlight,
    onItemClick: onItemClick,
    variation: "horizontal-highlight"
  }), getContentItems(itemHighlight).map(item => {
    return /*#__PURE__*/react.createElement(LuContentItem_LuContentItem, {
      key: item.id,
      data: item,
      cover: true,
      onItemClick: onItemClick,
      variation: "horizontal-highlight"
    });
  })))), /*#__PURE__*/react.createElement(Flex/* default */.Z, {
    justifyContent: "center",
    p: 3
  }, /*#__PURE__*/react.createElement(Button/* default */.Z, {
    as: "a",
    variation: "outline",
    color: "luContent",
    centered: true,
    uppercase: false,
    href: linkToMoreContent,
    onClick: onLoadMoreClick
  }, "Veja outros conte\xFAdos")));
};

 false ? 0 : void 0;
/* harmony default export */ var HorizontalHighlightContent = (BlogLuHorizontalHighlightContent);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/LuContent/variations/HorizontalContent.js









const HorizontalContent = ({
  onItemClick,
  onLoadMoreClick
}) => {
  const {
    data,
    linkToMoreContent,
    hide
  } = useLuContentContext();
  const items = reduceToSingleArray(data);
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(ListContentContainer, {
    itemsSize: items.length
  }, items.map(item => /*#__PURE__*/react.createElement(LuContentItem_LuContentItem, {
    key: item.id,
    vertical: true,
    data: item,
    onItemClick: onItemClick,
    itemsSize: items.length
  }))), /*#__PURE__*/react.createElement(Flex/* default */.Z, {
    justifyContent: "center",
    p: 3
  }, /*#__PURE__*/react.createElement(Button/* default */.Z, {
    as: "a",
    variation: "outline",
    color: "luContent",
    centered: true,
    uppercase: false,
    href: linkToMoreContent,
    onClick: onLoadMoreClick,
    hide: hide
  }, "Veja outros conte\xFAdos")));
};

 false ? 0 : void 0;
/* harmony default export */ var variations_HorizontalContent = (HorizontalContent);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/LuContent/variations/VerticalContent.js






const VerticalContent = ({
  onItemClick
}) => {
  const {
    data
  } = useLuContentContext();
  const items = reduceToSingleArray(data);
  return /*#__PURE__*/react.createElement(react.Fragment, null, items == null ? void 0 : items.map(item => /*#__PURE__*/react.createElement(LuContentItem_LuContentItem, {
    key: item.id,
    data: item,
    onItemClick: onItemClick
  })));
};

 false ? 0 : void 0;
/* harmony default export */ var variations_VerticalContent = (VerticalContent);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/LuContent/variations/index.js




;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/LuContent/LuContent.js








const Variations = {
  carousel: variations_CarouselContent,
  horizontal: variations_HorizontalContent,
  'horizontal-highlight': HorizontalHighlightContent,
  vertical: variations_VerticalContent
};

const LuContent = ({
  variation,
  title,
  linkToMoreContent,
  showLinkToMoreContent,
  data,
  assets,
  onItemClick,
  onSocialMediaClick,
  onLoadMoreClick,
  showHeaderSocialMedia
}) => {
  const carouselView = variation === 'carousel';
  const headerProps = carouselView ? {
    subtitle: title,
    borderRadius: 0
  } : {
    title
  };
  const {
    links,
    images
  } = assets;
  const VariationComponent = (Variations == null ? void 0 : Variations[variation]) || variations_VerticalContent;
  return /*#__PURE__*/react.createElement(LuContent_LuContentContext, {
    value: {
      images,
      data,
      links,
      linkToMoreContent
    }
  }, /*#__PURE__*/react.createElement(LuContent_styles_Container, {
    isVerticalView: variation === 'vertical'
  }, /*#__PURE__*/react.createElement(LuContentHeader_LuContentHeader, (0,esm_extends/* default */.Z)({}, headerProps, {
    showLinkToMoreContent: showLinkToMoreContent,
    onSocialMediaClick: onSocialMediaClick,
    showSocialMedias: showHeaderSocialMedia
  })), /*#__PURE__*/react.createElement(VariationComponent, {
    onItemClick: onItemClick,
    onLoadMoreClick: onLoadMoreClick,
    variation: variation
  }), carouselView && /*#__PURE__*/react.createElement(LuContentFooter_LuContentFooter, {
    onSocialMediaClick: onSocialMediaClick
  })));
};

const itemShape =  false ? 0 : {};
LuContent.defaultProps = {
  showDetailModal: true,
  showLinkToMoreContent: false,
  data: {
    articles: [],
    videos: [],
    podcasts: []
  },
  detailDirection: 'right',
  assets: {
    images: {
      luImage: '',
      luExplainImage: '',
      blogImage: ''
    }
  },
  onSocialMediaClick: () => {},
  showHeaderSocialMedia: false
};
 false ? 0 : void 0;
/* harmony default export */ var LuContent_LuContent = (LuContent);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/LuContent/index.js






/***/ }),

/***/ 4294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ review_result; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/index.js + 21 modules
var organisms = __webpack_require__(46514);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/ResponsiveImage/index.js + 2 modules
var ResponsiveImage = __webpack_require__(7029);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/ReviewResult/review-result.styles.js





const Container = styled_components_browser_esm/* default.div */.ZP.div`
  background-color: ${props => (0,esm/* getBackgroundColor */.dF)('white')(props)};
  padding: 16px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${(0,esm/* getMediaQuery */.aK)('large')} {
    padding: 0;
  }
`;
const Divider = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z)`
  border-bottom: 3px solid ${props => (0,esm/* getBorderColor */.kJ)('light')(props)};
  width: 100%;
`;
const Line = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z)`
  display: flex;
  align-items: center;

  ${(0,esm/* getMediaQuery */.aK)('large')} {
    &,
    & + div {
      display: none;
    }
  }
`;
const TitleReviewCharacteristics = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)`
  margin-bottom: 16px;
  font-size: ${props => (0,esm/* themeGet */.R)('fontSizes.3')(props)}px;
  font-weight: ${props => (0,esm/* themeGet */.R)('fontWeights.medium')(props)};

  ${(0,esm/* getMediaQuery */.aK)('large')} {
    align-self: self-start;
  }
`;
const SelectReviewSort = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z)`
  ${(0,esm/* getMediaQuery */.aK)('large')} {
    align-self: self-end;
    padding: 12px;
  }
`;
const ReviewList = styled_components_browser_esm/* default.ul */.ZP.ul`
  width: 100%;
`;
const Button = styled_components_browser_esm/* default.button */.ZP.button`
  outline: none;
  border-radius: 2px;
  padding: 10px 15px;
  height: 48px;
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  text-decoration: none;
  line-height: 1.5;
  width: 250px;
  margin-bottom: 10px;

  font-size: ${props => (0,esm/* themeGet */.R)('fontSizes.1')(props)}px;
  background-color: ${props => (0,esm/* getBackgroundColor */.dF)('white')(props)};
  border-color: ${props => (0,esm/* getBorderColor */.kJ)('base')(props)};
  color: ${props => (0,esm/* getTextColor */.uu)('base')(props)};
  text-transform: uppercase;
  border: 1px solid ${props => (0,esm/* getBorderColor */.kJ)('light')(props)};
`;
const Title = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)`
  max-width: 200px;
  margin-left: 10px;
  font-size: ${props => (0,esm/* themeGet */.R)('fontSizes.1')(props)}px;
  color: ${props => (0,esm/* getTextColor */.uu)('base')(props)};
  line-height: ${props => (0,esm/* themeGet */.R)('lineHeights.plus')(props)}px;

  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
`;
const ImageItem = (0,styled_components_browser_esm/* default */.ZP)(ResponsiveImage/* default */.Z)`
  width: ${props => props.width}px;
  height: ${props => props.height}px;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/ReviewResult/review-result.js







function ReviewResult({
  productData,
  reviewsData,
  onViewMoreClick,
  onChangeSort,
  showDesktop
}) {
  const {
    title,
    image
  } = productData || {};
  const {
    stats = {},
    reviews = [],
    sorts = [],
    pagination = {}
  } = reviewsData || {};
  const sortOptions = sorts == null ? void 0 : sorts.map(({
    label,
    type,
    orientation,
    selected
  }) => ({
    label,
    selected,
    value: `${type}-${orientation}`
  }));

  const handleChange = value => {
    if (value) {
      const [vType, vOrien] = value.split('-');
      const item = sorts == null ? void 0 : sorts.find(({
        type,
        orientation
      }) => type === vType && orientation === vOrien);
      onChangeSort(item);
    }
  };

  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Line, {
    p: "16px"
  }, /*#__PURE__*/react.createElement(ImageItem, {
    src: image,
    width: 50,
    height: 50
  }), /*#__PURE__*/react.createElement(Title, null, title)), /*#__PURE__*/react.createElement(Divider, null), /*#__PURE__*/react.createElement(Container, null, /*#__PURE__*/react.createElement(Divider, {
    m: "16px 0px",
    display: ['none', 'block']
  }), /*#__PURE__*/react.createElement(TitleReviewCharacteristics, null, "Avalia\xE7\xE3o geral"), /*#__PURE__*/react.createElement(organisms/* ReviewCharacteristics */.Ym, stats), /*#__PURE__*/react.createElement(Divider, {
    m: "16px 0px"
  }), !showDesktop && /*#__PURE__*/react.createElement(SelectReviewSort, null, /*#__PURE__*/react.createElement(atoms/* Select */.Ph, {
    id: "review-result",
    options: sortOptions,
    onChange: handleChange,
    mb: 20,
    "data-testid": "review-sort"
  })), showDesktop && /*#__PURE__*/react.createElement(SelectReviewSort, null, /*#__PURE__*/react.createElement(atoms/* Select */.Ph, {
    id: "review-result",
    options: sortOptions,
    onChange: handleChange,
    mb: 20,
    "data-testid": "review-sort",
    desktopMode: true,
    textLabel: "Ordenar avalia\xE7\xF5es:"
  })), /*#__PURE__*/react.createElement(ReviewList, null, reviews == null ? void 0 : reviews.map((item, idx) => /*#__PURE__*/react.createElement(organisms/* ReviewCard */.Ak, (0,esm_extends/* default */.Z)({
    key: `review-${idx}`
  }, item)))), (pagination == null ? void 0 : pagination.page) < (pagination == null ? void 0 : pagination.pages) && /*#__PURE__*/react.createElement(Button, {
    "data-testid": "review-more",
    onClick: onViewMoreClick
  }, "Carregar Mais")));
}

 false ? 0 : void 0;
ReviewResult.defaultProps = {
  showDesktop: false
};
/* harmony default export */ var review_result = (ReviewResult);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/ReviewResult/index.js


/***/ }),

/***/ 1756:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ sidebar_menu; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/lodash/lodash.js
var lodash = __webpack_require__(76635);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/HotLinks/index.js + 2 modules
var HotLinks = __webpack_require__(2490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/List/index.js + 10 modules
var List = __webpack_require__(78012);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(68054);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Link/index.js + 2 modules
var Link = __webpack_require__(10200);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/SidebarMenu/sidebar-menu.styles.js





const Container = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).attrs(() => ({
  backgroundColor: 'background.base',
  paddingBottom: 5
}))``;
const Content = styled_components_browser_esm/* default.nav */.ZP.nav`
  ${index_esm/* margin */.e6}
  padding: 0 ${props => (0,esm/* themeGet */.R)('space.2')(props)}px;
`;
const LogoutLink = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).attrs(() => ({
  backgroundColor: 'primary.base',
  color: 'text.lightest',
  paddingTop: 3,
  paddingBottom: 5,
  marginBottom: -5
}))``;
const Subtitle = styled_components_browser_esm/* default.small */.ZP.small`
  font-family: ${(0,esm/* themeGet */.R)('fontFamily')};
  display: block;
  margin: ${props => (0,esm/* themeGet */.R)('space.1')(props)}px
    ${props => (0,esm/* themeGet */.R)('space.2')(props)}px;
`;
const IconsContainer = styled_components_browser_esm/* default.div */.ZP.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(30px, max-content));
  justify-content: center;
  grid-gap: ${props => (0,esm/* themeGet */.R)('space.4')(props)}px;
`;
const SalesChannels = styled_components_browser_esm/* default.div */.ZP.div`
  margin: 10px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const SaleChannel = styled_components_browser_esm/* default.p */.ZP.p`
  svg {
    margin-right: 2px;
  }
  display: flex;
  align-items: center;
`;
const LinkContainer = styled_components_browser_esm/* default.div */.ZP.div`
  padding: 10px 16px;
`;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Toolbar/index.js + 4 modules
var Toolbar = __webpack_require__(93168);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/SidebarMenu/sidebar-heading.js






const SidebarHeading = ({
  data,
  onMenuHeaderClick
}) => {
  var _data$subtitles, _data$helpers;

  const hasSubtitles = ((_data$subtitles = data.subtitles) == null ? void 0 : _data$subtitles.length) > 0;
  return /*#__PURE__*/react.createElement(atoms/* Box */.xu, {
    bg: "background.primary",
    "data-testid": "sidebar-header"
  }, /*#__PURE__*/react.createElement(atoms/* Item */.ck, {
    scale: "medium",
    endIcon: "ChevronRight",
    fontWeight: "medium",
    variant: "primary",
    as: "a",
    ellipsis: data == null ? void 0 : data.ellipsis,
    href: data == null ? void 0 : data.url,
    rel: data == null ? void 0 : data.rel,
    onClick: e => onMenuHeaderClick(e, {
      url: data == null ? void 0 : data.url
    })
  }, data == null ? void 0 : data.label), hasSubtitles && data.subtitles.map(sub => /*#__PURE__*/react.createElement(Subtitle, {
    key: sub
  }, sub)), /*#__PURE__*/react.createElement(Toolbar/* default */.Z, {
    variant: "primary"
  }, data == null ? void 0 : (_data$helpers = data.helpers) == null ? void 0 : _data$helpers.map((item, index) => /*#__PURE__*/react.createElement(Toolbar/* default.Item */.Z.Item, {
    key: index,
    href: item == null ? void 0 : item.url,
    rel: item == null ? void 0 : item.rel,
    startIcon: item == null ? void 0 : item.id,
    onClick: e => onMenuHeaderClick(e, item)
  }, item == null ? void 0 : item.label))));
};

SidebarHeading.defaultProps = {
  onMenuHeaderClick: () => {}
};
 false ? 0 : void 0;
/* harmony default export */ var sidebar_heading = (SidebarHeading);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/SidebarMenu/sidebar-menu.js









const SidebarMenu = props => {
  var _categoryList$list, _categoryList$list2, _externalLinks$list, _externalLinks$list2, _services$list, _services$list2, _social$links;

  const {
    account,
    actionButtons,
    categoryList,
    externalLinks,
    header,
    helperText,
    salesChannels,
    moreInformation,
    services,
    showcaseLinks,
    groupedLinks,
    social
  } = (props == null ? void 0 : props.data) || {};
  const {
    onCollapsedClick,
    onMenuHeaderClick,
    onMenuItemClick,
    onLogout
  } = props;

  const getLabels = () => {
    if (Array.isArray(helperText)) {
      const [label, ...otherLabels] = helperText;
      return [label, otherLabels];
    }

    return [helperText || '', []];
  };

  const [label, otherLabels] = getLabels();
  const [collapsed, setCollapsed] = (0,react.useState)(true);

  const handleCollapsed = () => {
    onCollapsedClick();
    setCollapsed(!collapsed);
  };

  const [openIndices, setOpenIndices] = (0,react.useState)([]);

  const handleAccordionClick = index => {
    if (openIndices.includes(index)) {
      setOpenIndices(openIndices.filter(i => i !== index));
    } else {
      setOpenIndices([...openIndices, index]);
    }
  };

  return /*#__PURE__*/react.createElement(Container, null, header && /*#__PURE__*/react.createElement(sidebar_heading, {
    data: header,
    onMenuHeaderClick: onMenuHeaderClick
  }), /*#__PURE__*/react.createElement(Content, null, !!(showcaseLinks != null && showcaseLinks.length) && /*#__PURE__*/react.createElement(HotLinks/* default */.Z, {
    directionType: "column",
    items: showcaseLinks
  }), (groupedLinks == null ? void 0 : groupedLinks.map((group, i) => /*#__PURE__*/react.createElement(atoms/* Box */.xu, {
    bg: "white",
    borderRadius: 4,
    marginBottom: 10,
    marginTop: 10,
    key: i
  }, /*#__PURE__*/react.createElement(List/* default */.Z, {
    divided: true
  }, group.map((item, index) => /*#__PURE__*/react.createElement(List/* default.Item */.Z.Item, {
    key: index,
    as: "a",
    href: item == null ? void 0 : item.url,
    rel: item == null ? void 0 : item.rel,
    onClick: e => onMenuItemClick(e, item),
    startIcon: item.startIcon,
    fill: "background.primary",
    "data-testid": "menu-item"
  }, item == null ? void 0 : item.label)))))) || null, (categoryList == null ? void 0 : (_categoryList$list = categoryList.list) == null ? void 0 : _categoryList$list.length) && /*#__PURE__*/react.createElement(atoms/* Box */.xu, {
    bg: "white"
  }, /*#__PURE__*/react.createElement(List/* default.Collapse */.Z.Collapse, {
    trigger: collapsed,
    bg: "white",
    fill: "background.primary",
    collapsedIn: categoryList == null ? void 0 : categoryList.show,
    renderAction: collapsed && /*#__PURE__*/react.createElement(List/* default.Action */.Z.Action, {
      endIcon: "ChevronDown",
      fontWeight: "medium",
      onClick: handleCollapsed
    }, categoryList == null ? void 0 : categoryList.collapseText),
    divided: true,
    "data-testid": "category-list"
  }, categoryList == null ? void 0 : (_categoryList$list2 = categoryList.list) == null ? void 0 : _categoryList$list2.map((item, index) => {
    var _item$subcategoriesLi;

    return /*#__PURE__*/react.createElement(atoms/* Box */.xu, {
      key: index,
      bg: "white",
      borderRadius: 4
    }, (item == null ? void 0 : item.subcategoriesList) && /*#__PURE__*/react.createElement(atoms/* Accordion */.UQ, {
      id: item == null ? void 0 : item.id,
      title: item.label,
      closeIcon: "ChevronUp",
      open: openIndices.includes(index),
      onClick: () => handleAccordionClick(index),
      fontWeight: "regular",
      openIcon: "ChevronDown",
      mb: "1px"
    }, /*#__PURE__*/react.createElement(atoms/* Box */.xu, {
      bg: "#F4F4F4",
      borderRadius: 4,
      height: "350px",
      overflow: "scroll"
    }, item == null ? void 0 : (_item$subcategoriesLi = item.subcategoriesList) == null ? void 0 : _item$subcategoriesLi.map((subItem, value) => /*#__PURE__*/react.createElement(LinkContainer, {
      key: value
    }, /*#__PURE__*/react.createElement(atoms/* Link */.rU, {
      as: "a",
      href: subItem == null ? void 0 : subItem.url,
      rel: subItem == null ? void 0 : subItem.rel,
      color: subItem.highlight ? 'rgb(164, 0, 225)' : null,
      onClick: e => onMenuItemClick(e, subItem, 'subcategoria:')
    }, subItem == null ? void 0 : subItem.label))))), !(item != null && item.subcategoriesList) && /*#__PURE__*/react.createElement(List/* default */.Z, {
      divided: true
    }, /*#__PURE__*/react.createElement(List/* default.Item */.Z.Item, {
      key: index,
      as: "a",
      href: (item == null ? void 0 : item.path) || (item == null ? void 0 : item.url),
      rel: item == null ? void 0 : item.rel,
      onClick: e => onMenuItemClick(e, item),
      startIcon: item != null && item.id ? `Category${item == null ? void 0 : item.id}` : undefined,
      fill: "background.primary",
      "data-testid": "menu-item",
      mb: "1px"
    }, item == null ? void 0 : item.label)));
  }))), (externalLinks == null ? void 0 : (_externalLinks$list = externalLinks.list) == null ? void 0 : _externalLinks$list.length) && /*#__PURE__*/react.createElement(atoms/* Box */.xu, {
    mt: 3
  }, /*#__PURE__*/react.createElement(atoms/* Text */.xv, {
    fontWeight: "medium",
    px: 3,
    py: 3
  }, externalLinks == null ? void 0 : externalLinks.title), /*#__PURE__*/react.createElement(List/* default */.Z, {
    bg: "white",
    borderRadius: 4,
    divided: true
  }, externalLinks == null ? void 0 : (_externalLinks$list2 = externalLinks.list) == null ? void 0 : _externalLinks$list2.map((item, index) => /*#__PURE__*/react.createElement(List/* default.Item */.Z.Item, {
    key: index,
    as: "a",
    href: item == null ? void 0 : item.url,
    rel: item == null ? void 0 : item.rel,
    startIcon: (item == null ? void 0 : item.id) && `Logo${item == null ? void 0 : item.id}`,
    endIcon: item == null ? void 0 : item.endIcon,
    fontWeight: item == null ? void 0 : item.fontWeight,
    onClick: e => onMenuItemClick(e, item, 'nossas-marcas:')
  }, item == null ? void 0 : item.label)))), (services == null ? void 0 : (_services$list = services.list) == null ? void 0 : _services$list.length) && /*#__PURE__*/react.createElement(atoms/* Box */.xu, {
    mt: 3
  }, /*#__PURE__*/react.createElement(atoms/* Text */.xv, {
    fontWeight: "medium",
    px: 3,
    py: 3
  }, services == null ? void 0 : services.title), /*#__PURE__*/react.createElement(List/* default */.Z, {
    bg: "white",
    borderRadius: 4,
    divided: true
  }, services == null ? void 0 : (_services$list2 = services.list) == null ? void 0 : _services$list2.map((item, index) => /*#__PURE__*/react.createElement(List/* default.Item */.Z.Item, {
    key: index,
    as: "a",
    href: item == null ? void 0 : item.url,
    rel: item == null ? void 0 : item.rel,
    startIcon: `Service${item == null ? void 0 : item.id}`,
    fill: "gray",
    onClick: e => onMenuItemClick(e, item, 'servicos:')
  }, item == null ? void 0 : item.label)))), (moreInformation == null ? void 0 : moreInformation.length) && /*#__PURE__*/react.createElement(atoms/* Box */.xu, {
    mt: 2
  }, /*#__PURE__*/react.createElement(List/* default */.Z, {
    bg: "white",
    borderRadius: 4,
    divided: true
  }, moreInformation == null ? void 0 : moreInformation.map((item, index) => /*#__PURE__*/react.createElement(List/* default.Item */.Z.Item, {
    key: index,
    as: "a",
    href: item == null ? void 0 : item.url,
    rel: item == null ? void 0 : item.rel,
    startIcon: item == null ? void 0 : item.id,
    fill: "gray",
    onClick: e => onMenuItemClick(e, item)
  }, item == null ? void 0 : item.label)))), (actionButtons == null ? void 0 : actionButtons.length) && /*#__PURE__*/react.createElement(atoms/* Box */.xu, {
    mt: 3
  }, actionButtons == null ? void 0 : actionButtons.map((item, index) => /*#__PURE__*/react.createElement(atoms/* Button */.zx, {
    key: index,
    href: item == null ? void 0 : item.url,
    rel: item == null ? void 0 : item.rel,
    as: "a",
    color: "primary",
    startIcon: item == null ? void 0 : item.id,
    uppercase: false,
    mb: 2,
    centered: true,
    full: true,
    onClick: e => onMenuItemClick(e, item, 'contato:')
  }, item == null ? void 0 : item.label)))), label && /*#__PURE__*/react.createElement(atoms/* Box */.xu, {
    mt: 4
  }, /*#__PURE__*/react.createElement(atoms/* Text */.xv, {
    fontSize: 1,
    textAlign: "center",
    color: "darkGray"
  }, label), /*#__PURE__*/react.createElement(SalesChannels, {
    "data-testid": "sales-channels"
  }, salesChannels == null ? void 0 : salesChannels.map(saleChannel => /*#__PURE__*/react.createElement(SaleChannel, {
    key: lodash_default().uniqueId('salesChannelsSideBar')
  }, saleChannel.icon, /*#__PURE__*/react.createElement(atoms/* Text */.xv, {
    fontSize: 3,
    color: "darkGray"
  }, saleChannel.label)))), otherLabels == null ? void 0 : otherLabels.map((item, index) => /*#__PURE__*/react.createElement(atoms/* Text */.xv, {
    key: index,
    fontSize: 1,
    textAlign: "center",
    color: "darkGray",
    fontWeight: "medium"
  }, item))), !!(social != null && (_social$links = social.links) != null && _social$links.length) && /*#__PURE__*/react.createElement(atoms/* Box */.xu, {
    m: 3
  }, /*#__PURE__*/react.createElement(atoms/* Text */.xv, {
    fontSize: "small",
    py: 2,
    textAlign: "center"
  }, social == null ? void 0 : social.title), /*#__PURE__*/react.createElement(atoms/* HorizontalRule */.bo, {
    style: {
      margin: '0 auto 12px',
      width: '50%'
    }
  }), /*#__PURE__*/react.createElement(IconsContainer, null, social.links.map((item, index) => /*#__PURE__*/react.createElement("a", {
    key: index,
    rel: "noreferrer",
    href: item == null ? void 0 : item.url,
    target: "_blank",
    title: item == null ? void 0 : item.label
  }, /*#__PURE__*/react.createElement(atoms/* Image */.Ee, {
    src: item == null ? void 0 : item.img,
    alt: item == null ? void 0 : item.label
  }))))), (account == null ? void 0 : account.name) && /*#__PURE__*/react.createElement(LogoutLink, {
    "data-testid": "logout-link",
    onClick: onLogout,
    href: account == null ? void 0 : account.signOutUrl,
    bg: "primary",
    underlineOnHover: false,
    textAlign: "center",
    underline: true,
    mt: 4,
    py: 3
  }, "N\xE3o \xE9 ", account == null ? void 0 : account.name, "? Sair"));
};

SidebarMenu.defaultProps = {
  onLogout: () => {},
  onMenuHeaderClick: () => {},
  onCollapsedClick: () => {},
  onMenuItemClick: () => ({}),
  groupedLinks: []
};
 false ? 0 : void 0;
/* harmony default export */ var sidebar_menu = (SidebarMenu);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/SidebarMenu/index.js


/***/ }),

/***/ 91061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Toolbar; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/index.js + 33 modules
var molecules = __webpack_require__(39146);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/index.js + 21 modules
var organisms = __webpack_require__(46514);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/FilterMenu/index.js + 3 modules
var FilterMenu = __webpack_require__(33252);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/Toolbar/toolbar.styles.js




const ListOptions = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z)`
  display: flex;
  height: 40px;
  justify-content: space-around;
  box-shadow: -1px 2px 4px 0 rgba(0, 0, 0, 0.14);
  font-size: ${props => (0,esm/* themeGet */.R)('fontSizes.1')(props)}px;
  font-weight: ${props => (0,esm/* themeGet */.R)('fontWeights.medium')(props)};
  background-color: ${props => (0,esm/* getPaletteColor */.ow)('background.base')(props)};
  color: ${props => (0,esm/* getPaletteColor */.ow)('text.scratched')(props)};

  > div {
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    border-left: 1px solid ${props => (0,esm/* themeGet */.R)('colors.whisper')(props)};
  }

  > div:first-child {
    border-left-style: none;
  }
`;
const toolbar_styles_Text = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs(props => ({
  color: (0,esm/* getPaletteColor */.ow)('text.scratched')(props)
}))``;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/ListDisplayType/index.js + 2 modules
var ListDisplayType = __webpack_require__(33359);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/Toolbar/toolbar.js








function Toolbar({
  defaultDisplayMode,
  onChangeDisplayMode,
  onChangeSort,
  onFiltersClear,
  onFilterClick,
  onFilterItemClick,
  onFilterTypeClick,
  sortOptions,
  sortLabel,
  showSelectedOptionLabel,
  filters,
  showFilters,
  filtersCount,
  showDisplayType
}) {
  var _sortOptions$find;

  const [sortOpen, setSortOpen] = (0,react.useState)(false);
  const [filterOpen, setFilterOpen] = (0,react.useState)(false);

  function handleSortChange(e, option) {
    onChangeSort(option);
    setSortOpen(false);
  }

  const handleFiltersClear = () => {
    setFilterOpen(!filterOpen);
    onFiltersClear();
  };

  const handleFilterClick = () => {
    onFilterClick(!filterOpen);
    setFilterOpen(!filterOpen);
  };

  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(ListOptions, {
    fontSize: 1
  }, showDisplayType && !!onChangeDisplayMode && /*#__PURE__*/react.createElement(ListDisplayType/* default */.Z, {
    onChange: onChangeDisplayMode,
    defaultMode: defaultDisplayMode
  }), sortOptions != null && sortOptions.length ? /*#__PURE__*/react.createElement(atoms/* Box */.xu, {
    p: 1,
    onClick: () => setSortOpen(!sortOpen),
    "data-testid": "orderby-btn"
  }, /*#__PURE__*/react.createElement(toolbar_styles_Text, {
    "data-testid": "sort-label"
  }, showSelectedOptionLabel ? ((_sortOptions$find = sortOptions.find(option => option.selected)) == null ? void 0 : _sortOptions$find.label) || sortLabel : sortLabel)) : /*#__PURE__*/react.createElement(react.Fragment, null), showFilters && /*#__PURE__*/react.createElement(FilterMenu/* default */.Z, {
    visible: filterOpen,
    filters: filters,
    count: filtersCount,
    onItemClick: onFilterItemClick,
    onOpen: handleFilterClick,
    onClickOutside: handleFilterClick,
    onClose: handleFilterClick,
    onClear: handleFiltersClear,
    onShowDetail: onFilterTypeClick
  })), sortOptions != null && sortOptions.length ? /*#__PURE__*/react.createElement(organisms/* Sidebar */.YE, {
    headerTitle: sortLabel,
    visible: sortOpen,
    direction: "right",
    onClickOutside: () => setSortOpen(false)
  }, /*#__PURE__*/react.createElement(molecules/* RadioGroup */.Ee, {
    options: sortOptions,
    onChange: handleSortChange,
    p: '12px 0 12px 20px'
  })) : /*#__PURE__*/react.createElement(react.Fragment, null));
}
Toolbar.defaultProps = {
  defaultDisplayMode: 'gallery',
  onChangeSort: () => {},
  onFiltersClear: () => ({}),
  onFilterClick: () => ({}),
  onFilterItemClick: {},
  sortLabel: 'Ordenar por',
  sortOptions: [],
  showSelectedOptionLabel: true,
  filters: {},
  filtersCount: 0,
  showFilters: false,
  showDisplayType: false
};
 false ? 0 : void 0;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/Toolbar/index.js


/***/ }),

/***/ 7123:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {


// UNUSED EXPORTS: BuyBoxList, FilterCarplateMenu, FilterMenu, FinancialServices, Footer, FooterDesktop, Header, HeaderDesktop, LuContent, ReviewResult, SidebarMenu, Toolbar

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/BuyBox/index.js + 2 modules
var BuyBox = __webpack_require__(72848);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/FilterMenu/index.js + 3 modules
var FilterMenu = __webpack_require__(33252);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/AlertText/index.js + 2 modules
var AlertText = __webpack_require__(52337);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/FilterCarplateMenu/filter-carplate-menu.styles.js




const ALERT_COLORS = {
  warning: '#fed34e',
  error: '#E41C41'
};
const ALERT_TEXT_COLORS = {
  warning: '#1E2428E5'
};

const handleAlertColor = props => ALERT_TEXT_COLORS[props.type] || (0,esm/* getBackgroundColor */.dF)('lighter')(props);

const handleAlertBackground = props => ALERT_COLORS[props.type] || (0,esm/* getBackgroundColor */.dF)('primary')(props);

const BaseContainer = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Flex */.kC)`
  flex-direction: column;
  border-radius: 8px;
  gap: 24px;
  background-color: ${(0,esm/* themeGet */.R)('palette.background.lighter')};
`;
const Container = (0,styled_components_browser_esm/* default */.ZP)(BaseContainer)`
  width: 100%;
  margin-top: ${({
  marginTop
}) => marginTop || '8px'};
  ${({
  withBorder
}) => withBorder && styled_components_browser_esm/* css */.iv`
      border: 1px solid #d3dadd;
    `}
`;
const AlertContent = (0,styled_components_browser_esm/* default */.ZP)(BaseContainer)`
  width: 100%;

  svg {
    min-width: 24px;
  }
`;
const CustomAlertText = (0,styled_components_browser_esm/* default */.ZP)(AlertText/* default */.Z).attrs(props => Object.assign({
  styleContainer: {
    backgroundColor: handleAlertBackground(props),
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px'
  },
  styleMessage: {
    fontSize: `${(0,esm/* themeGet */.R)('fontSizes.')(props)}px`,
    fontWeight: (0,esm/* themeGet */.R)('fontWeights.regular')(props),
    lineHeight: `${(0,esm/* themeGet */.R)('lineHeights.tall')(props)}px`,
    color: handleAlertColor(props),
    padding: '15px 24px'
  }
}, props))``;
const CardTitle = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Heading */.X6)`
  font-weight: ${(0,esm/* themeGet */.R)('fontWeights.bold')};
  font-size: ${(0,esm/* themeGet */.R)('fontSizes.2')}px;
`;
const CardBody = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Flex */.kC)`
  flex-direction: ${({
  isRow
}) => isRow ? 'row' : 'column'};
  width: 100%;
  gap: 24px;
`;
const CardContent = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Flex */.kC)`
  flex-direction: column;
  padding: 24px;
  gap: 24px;
  width: 100%;

  ${({
  isAlert
}) => isAlert && styled_components_browser_esm/* css */.iv`
      padding-top: 0;
    `}
`;
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/FilterCarplateMenu/filter-carplate-menu.constrants.js

const ALERT_ICONS = {
  error: 'ErrorOutline',
  info: 'CheckCircle',
  warning: 'WarningOutline'
};
const DEFAULT_ALERT_CONTENT = {
  type: '',
  message: ''
};
const PROPTYPES = {
  title: prop_types.string,
  children: prop_types.node,
  alertContent: (0,prop_types.shape)({
    message: prop_types.string,
    type: prop_types.string
  }),
  withBorder: prop_types.bool
};
const DEFAULT_PROPS = {
  title: '',
  children: null,
  alertContent: DEFAULT_ALERT_CONTENT,
  withBorder: false
};
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/FilterCarplateMenu/filter-carplate-menu.js






const getAlertDetails = ({
  message,
  type
}) => {
  const icon = ALERT_ICONS[type];
  if (!message || !icon) return null;
  return {
    message,
    type,
    icon
  };
};

const renderAlertContent = alertDetails => {
  if (!alertDetails) return null;
  return /*#__PURE__*/react.createElement(AlertContent, {
    "data-testid": "alert-content"
  }, /*#__PURE__*/react.createElement(CustomAlertText, {
    message: {
      text: alertDetails.message
    },
    icon: alertDetails.icon,
    type: alertDetails.type
  }));
};

const FilterCarplateMenu = _ref => {
  let {
    title,
    children,
    alertContent,
    withBorder
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["title", "children", "alertContent", "withBorder"]);

  const alertDetails = getAlertDetails(alertContent || DEFAULT_ALERT_CONTENT);
  if (!title && !children) return null;
  return /*#__PURE__*/react.createElement(Container, (0,esm_extends/* default */.Z)({
    "data-testid": "card",
    withBorder: withBorder
  }, props), renderAlertContent(alertDetails), /*#__PURE__*/react.createElement(CardContent, {
    isAlert: Boolean(alertDetails)
  }, title && /*#__PURE__*/react.createElement(CardTitle, {
    "data-testid": "card-title"
  }, title), children && /*#__PURE__*/react.createElement(CardBody, {
    "data-testid": "card-content",
    isRow: props.isRow
  }, children)));
};

 false ? 0 : void 0;
FilterCarplateMenu.defaultProps = DEFAULT_PROPS;
/* harmony default export */ var filter_carplate_menu = ((/* unused pure expression or super */ null && (FilterCarplateMenu)));
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/FilterCarplateMenu/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/FinancialServices/index.js + 22 modules
var FinancialServices = __webpack_require__(99852);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/FooterDesktop/index.js + 7 modules
var FooterDesktop = __webpack_require__(70385);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/Footer/index.js + 2 modules
var Footer = __webpack_require__(49647);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/HeaderDesktop/index.js + 5 modules
var HeaderDesktop = __webpack_require__(42887);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/Header/index.js + 2 modules
var Header = __webpack_require__(71782);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/LuContent/index.js + 22 modules
var LuContent = __webpack_require__(95949);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/ReviewResult/index.js + 2 modules
var ReviewResult = __webpack_require__(4294);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/SidebarMenu/index.js + 3 modules
var SidebarMenu = __webpack_require__(1756);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/Toolbar/index.js + 2 modules
var Toolbar = __webpack_require__(91061);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/index.js













/***/ }),

/***/ 68609:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

const handlers = {
  handleInitialLetters: char => {
    if (/[a-zA-Z]/.test(char)) {
      return char.toUpperCase();
    }

    return '';
  },
  handleFirstDigit: char => {
    if (/[0-9]/.test(char)) {
      return `-${char}`;
    }

    return '';
  },
  handleDigitOrLetter: char => {
    if (/[a-zA-Z0-9]/.test(char)) {
      return char.toUpperCase();
    }

    return '';
  },
  handleFinalDigits: char => {
    if (/[0-9]/.test(char)) {
      return char;
    }

    return '';
  },
  stop: () => ''
};

const getHandlerKey = count => {
  if (count < 3) return 'handleInitialLetters';
  if (count === 3) return 'handleFirstDigit';
  if (count === 4) return 'handleDigitOrLetter';
  if (count < 7) return 'handleFinalDigits';
  return 'stop';
};

const carPlateMask = value => {
  const cleanedValue = String(value).replace(/[^a-zA-Z0-9]/g, '');
  let maskedValue = '';
  let maskedCount = 0;

  for (let i = 0; i < cleanedValue.length; i += 1) {
    if (maskedValue.length >= 8) break;
    const handlerKey = getHandlerKey(maskedCount);
    const newPart = handlers[handlerKey](cleanedValue[i]);

    if (newPart) {
      maskedValue += newPart;
      maskedCount += 1;
    }
  }

  return maskedValue;
};

/* harmony default export */ __webpack_exports__["Z"] = (carPlateMask);

/***/ }),

/***/ 13111:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

const emailMask = value => {
  const emailRegex = /^[\w-]+(\.[\w-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,20})$/i;
  return emailRegex.test(value);
};

/* harmony default export */ __webpack_exports__["Z"] = (emailMask);

/***/ }),

/***/ 15312:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

const fullNameMask = value => {
  return value && value.trim().split(' ').length > 1 || false;
};

/* harmony default export */ __webpack_exports__["Z"] = (fullNameMask);

/***/ }),

/***/ 98047:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

const getVariation = (variations, value) => {
  return variations.find(varAttr => (varAttr == null ? void 0 : varAttr.value) === value);
};

/* harmony default export */ __webpack_exports__["Z"] = (getVariation);

/***/ }),

/***/ 86349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "kC": function() { return /* reexport */ utils_capitalize; },
  "lb": function() { return /* reexport */ checkAndCalculateTime; },
  "vQ": function() { return /* reexport */ copyToClipboard; },
  "qJ": function() { return /* reexport */ utils_embedYoutubeUrl; },
  "Ji": function() { return /* reexport */ fadeIn; },
  "bd": function() { return /* reexport */ fetchFormattedTime; },
  "Qd": function() { return /* reexport */ utils_formatDiscountMessage; },
  "J5": function() { return /* reexport */ formatTimeRemainingToISO; },
  "lm": function() { return /* reexport */ utils_getAvailability; },
  "KF": function() { return /* reexport */ getVariation/* default */.Z; },
  "xx": function() { return /* reexport */ isInternationalPrice/* default */.Z; },
  "rx": function() { return /* reexport */ isMaxValidValue; },
  "Z4": function() { return /* reexport */ isMinValidValue; },
  "RZ": function() { return /* reexport */ utils_locationText; },
  "zY": function() { return /* reexport */ utils_parseDescriptionValue; },
  "az": function() { return /* reexport */ scaleUpCenter; },
  "$7": function() { return /* reexport */ slideFromBottom; },
  "ie": function() { return /* reexport */ slideFromTop; },
  "hY": function() { return /* reexport */ utils_sortByAvailable; },
  "gf": function() { return /* reexport */ sortBySelected/* default */.Z; },
  "IC": function() { return /* reexport */ utils_sortCategoriesList; },
  "yH": function() { return /* reexport */ sort_services; },
  "O": function() { return /* reexport */ useHideOverflownElements; },
  "t$": function() { return /* reexport */ useOnClickOutside; },
  "Ay": function() { return /* reexport */ useOnMouseHover; },
  "CK": function() { return /* reexport */ zipcodeMask/* default */.Z; }
});

// UNUSED EXPORTS: arrayToObject, carPlateMask, emailMask, fullNameMask, getCurrentDateWithHourAdjustment, isInRange, moneyMask, parseAttributeValue, truncate

;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/capitalize.js
const capitalize = s => {
  if (typeof s !== 'string') return '';
  return s.toLowerCase().charAt(0).toUpperCase() + s.slice(1);
};

/* harmony default export */ var utils_capitalize = (capitalize);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/copyToClipboard.js
async function copyToClipboard(text) {
  var _navigator, _navigator$clipboard;

  if ((_navigator = navigator) != null && (_navigator$clipboard = _navigator.clipboard) != null && _navigator$clipboard.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (error) {
      console.error('Erro ao copiar para a área de transferência:', error);
      return false;
    }
  } // old browsers fallback


  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'absolute';
  textarea.style.left = '-9999px';
  document.body.appendChild(textarea);
  textarea.select();
  let success = false;

  try {
    success = document.execCommand('copy');
  } catch (error) {
    console.error('Erro ao copiar o texto usando fallback:', error);
  }

  document.body.removeChild(textarea);
  return success;
}
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/embedYoutubeUrl.js
const embedYoutubeUrl = url => {
  if (!url || typeof url !== 'string' || !url.includes('www.youtube.com/v/')) return url;
  const groups = url.match(/v\/([a-zA-Z0-9_-]+)&?/);
  const id = groups != null && groups.length ? groups[1] : null;
  if (!id) return url;
  return `https://www.youtube.com/embed/${id}`;
};

/* harmony default export */ var utils_embedYoutubeUrl = (embedYoutubeUrl);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/getVariation.js
var getVariation = __webpack_require__(98047);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/truncate.js
/**
 * Ellipsis long strings
 * @param {int} count - max length
 * @param {string} long - string to truncate
 * @example truncate(24, 'Vila Bela da Santíssima Trindade') => will return Vila Bela da Santíssi...
 * @example truncate(24, 'Santo André') => will return Santo André
 */
const truncate = (count, long = '') => {
  let maxLength = count;
  if (long.length < maxLength) return long;
  if (maxLength === 3) maxLength += 3;
  return `${long.substr(0, maxLength - 3)}...`;
};

/* harmony default export */ var utils_truncate = (truncate);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/zipcodeMask.js
var zipcodeMask = __webpack_require__(7874);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/locationText.js



const locationText = ({
  zipCode = '',
  zipCodeCity = '',
  zipCodeState = '',
  maxCityLength = 24,
  formatter = (city, state) => `${city.toUpperCase()}, ${state.toUpperCase()}`,
  includeAddress = true
} = {}) => {
  const city = zipCodeCity && typeof zipCodeCity === 'string' ? utils_truncate(maxCityLength, zipCodeCity) : '';
  const state = zipCodeState && typeof zipCodeState === 'string' ? zipCodeState : '';
  const zipcode = zipCode && typeof zipCode === 'string' ? zipCode : '';
  const textLocation = formatter(city, state);
  return includeAddress ? `${textLocation} - ${(0,zipcodeMask/* default */.Z)(zipcode)}` : (0,zipcodeMask/* default */.Z)(zipcode);
};

/* harmony default export */ var utils_locationText = (locationText);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/moneyMask.js
var moneyMask = __webpack_require__(63113);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/range.js
const isInRange = (value, minAllowed, maxAllowed) => minAllowed <= value && value <= maxAllowed;
const isMinValidValue = (value, currentMax, minAllowed, maxAllowed) => isInRange(value, minAllowed, maxAllowed) && value < currentMax;
const isMaxValidValue = (value, currentMin, minAllowed, maxAllowed) => isInRange(value, minAllowed, maxAllowed) && value > currentMin;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/parseDescriptionValue.js
const parseDescriptionValue = value => {
  const startSentence = (value == null ? void 0 : value.length) > 1 ? 'dos seguros' : 'do seguro';
  const descriptions = value.join(', ').replace(/, ([^,]*)$/, ' e $1').toLowerCase();
  return `${startSentence} ${descriptions}`;
};

/* harmony default export */ var utils_parseDescriptionValue = (parseDescriptionValue);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/sort-services.js
const sortServices = (services = [], priority = []) => {
  return priority.map(item => services.find(service => Number(service == null ? void 0 : service.id) === item));
};

/* harmony default export */ var sort_services = (sortServices);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/arrayToObject.js
const arrayToObject = (array = [], key = null) => {
  if (!key) {
    throw new Error('Invalid parameter [key]');
  }

  if (!array.length) return {};
  return array.reduce((obj, item) => {
    return Object.assign({}, obj, {
      [item[key]]: item
    });
  }, {});
};

/* harmony default export */ var utils_arrayToObject = (arrayToObject);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/sortCategoriesList.js

/**
 * returns an ordered list (onderBy + rest)
 * @param {*} list - [obj1, obj2, obj3, obj4, obj5]
 * @param {*} orderBy  - ['3', '2']
 *
 */

const sortCategoriesList = (list = [], orderBy = []) => {
  if (!orderBy.length || !list.length) {
    return list;
  }

  if (!orderBy.every(i => typeof i === 'string')) {
    throw new Error('Invalid parameter [orderBy]');
  } // easy access to item


  const listObj = utils_arrayToObject(list, 'id');
  const otherIDs = Object.keys(listObj).filter(key => !orderBy.includes(key)); // get ordered list first and the other objs

  const ordered = orderBy.map(item => listObj[item]).slice(0, list.length);
  const rest = otherIDs.map(item => listObj[item]);
  return [...ordered, ...rest];
};

/* harmony default export */ var utils_sortCategoriesList = (sortCategoriesList);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/sortByAvailable.js


const sortByAvailable = (attribute = {}) => (variations = []) => {
  var _attribute$values;

  const variationValues = (attribute == null ? void 0 : (_attribute$values = attribute.values) == null ? void 0 : _attribute$values.reduce((acc, value) => {
    const variation = (0,getVariation/* default */.Z)(variations, value);
    return Object.assign({}, acc, {
      [value]: variation == null ? void 0 : variation.available
    });
  }, {})) || {};
  return Object.entries(variationValues).sort(([, a], [, b]) => b - a).map(([key]) => key);
};

/* harmony default export */ var utils_sortByAvailable = (sortByAvailable);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/sortBySelected.js
var sortBySelected = __webpack_require__(41869);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/isInternationalPrice.js
var isInternationalPrice = __webpack_require__(97728);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/useHideOverflownElements.js

/**
 * Hide elements if their widths overflow a container's width
 * @param {{ [key: string]: import('react').RefObject<HTMLElement> }} elementRefs
 * @param {import('react').RefObject<HTMLElement>} containerRef
 * @param {String} defaultDisplay CSS "display" value if element isn't overflown. Defaults to "block"
 */

/* harmony default export */ var useHideOverflownElements = ((elementRefs, containerRef, defaultDisplay = 'block') => {
  (0,react.useEffect)(() => {
    const markOverflowingMenus = () => {
      // Reset elements display
      Object.values(elementRefs).forEach(elementRef => {
        elementRef.current.style.display = defaultDisplay;
      }); // Hide overflown elements

      Object.values(elementRefs).filter(elementRef => elementRef.current.offsetLeft + elementRef.current.offsetWidth > containerRef.current.offsetWidth + containerRef.current.offsetLeft).forEach(overflownElementRef => {
        overflownElementRef.current.style.display = 'none';
      });
    };

    markOverflowingMenus();
    window.addEventListener('resize', markOverflowingMenus);
    return () => {
      window.removeEventListener('resize', markOverflowingMenus);
    };
  }, [containerRef.current]);
});
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/useOnClickOutside.js

/* https://usehooks.com/useOnClickOutside/ */

/* harmony default export */ var useOnClickOutside = ((ref, handler) => {
  (0,react.useEffect)(() => {
    const listener = event => {
      // Do nothing if clicking ref's element or descendent elements
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, // Add ref and handler to effect dependencies
  // It's worth noting that because passed in handler is a new ...
  // ... function on every render that will cause this effect ...
  // ... callback/cleanup to run every render. It's not a big deal ...
  // ... but to optimize you can wrap handler in useCallback before ...
  // ... passing it into this hook.
  [ref, handler]);
});
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/useOnMouseHover.js
/* eslint consistent-return: off */

/**
 * Sensor hook that determine if the mouse element is in the hover element
 *
 * @param  {} ref
 * @param  {} handler
 */

/* harmony default export */ var useOnMouseHover = ((ref, handler) => {
  (0,react.useEffect)(() => {
    const handleMouseEnter = () => handler(true);

    const handleMouseLeave = () => handler(false);

    const node = ref == null ? void 0 : ref.current;

    if (node) {
      node.addEventListener('mouseenter', handleMouseEnter);
      node.addEventListener('mouseleave', handleMouseLeave);
      return () => {
        node.removeEventListener('mouseenter', handleMouseEnter);
        node.removeEventListener('mouseleave', handleMouseLeave);
      };
    }
  }, [ref]);
});
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/getAvailability.js
const getAvailability = (variations, value) => {
  return variations.some(varAttr => (varAttr == null ? void 0 : varAttr.value) === value && (varAttr == null ? void 0 : varAttr.available) === true);
};

/* harmony default export */ var utils_getAvailability = (getAvailability);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-utils/build/esm/index.js
var esm = __webpack_require__(71180);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/formatDiscountMessage.js


const formatDiscountMessage = tags => {
  const {
    discountValue,
    discountType
  } = tags || {};
  if (typeof discountValue !== 'number' || discountValue <= 0) return null;
  const formattedDiscount = Math.trunc(discountValue);
  const formats = {
    percentage: `${formattedDiscount}% OFF`,
    absolute: `${(0,esm/* currencyFormatter */.oB)({
      value: formattedDiscount,
      decimal: false,
      locale: 'pt-br'
    }).replace(/\u00A0/g, ' ')} OFF`
  };
  return formats[discountType] || null;
};

/* harmony default export */ var utils_formatDiscountMessage = (formatDiscountMessage);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/timerRemainingOffeer.js
const MS_IN_SECOND = 1000;
const MS_IN_MINUTE = MS_IN_SECOND * 60;
const MS_IN_HOUR = MS_IN_MINUTE * 60;

const twoDigitString = source => String(source).padStart(2, '0');

function calculateTimeParts(ms) {
  const hours = Math.floor(ms / MS_IN_HOUR);
  ms %= MS_IN_HOUR;
  const minutes = Math.floor(ms / MS_IN_MINUTE);
  ms %= MS_IN_MINUTE;
  const seconds = Math.floor(ms / MS_IN_SECOND);
  const isInvalidParts = typeof hours === 'undefined' || typeof minutes === 'undefined' || typeof seconds === 'undefined' || Number.isNaN(hours) || Number.isNaN(minutes) || Number.isNaN(seconds);
  return isInvalidParts ? '' : {
    hours,
    minutes,
    seconds
  };
}

function checkAndCalculateTime(restrictions, currentTime) {
  if (!restrictions) {
    return {
      show: false,
      timeRemainingFormatted: '00:00:00'
    };
  }

  const {
    timer_start_date,
    timer_end_date
  } = restrictions || {};
  const currentDateTime = new Date(currentTime).getTime();
  const startDate = new Date(timer_start_date).getTime();
  const endDate = new Date(timer_end_date).getTime();
  const isOutOfRange = currentDateTime < startDate || endDate <= currentDateTime;
  const isInvalidDates = !startDate || !endDate;

  if (isInvalidDates || isOutOfRange) {
    return {
      show: false,
      timeRemainingFormatted: '00:00:00'
    };
  }

  const timeRemaining = endDate - currentDateTime;
  const {
    hours,
    minutes,
    seconds
  } = calculateTimeParts(timeRemaining);
  const timeRemainingFormatted = `${twoDigitString(hours)}:${twoDigitString(minutes)}:${twoDigitString(seconds)}`;
  return {
    show: true,
    timeRemainingFormatted
  };
}

function formatTimeRemainingToISO(timeString) {
  if (typeof timeString !== 'string' || !timeString.trim()) return '';
  const [hours, minutes] = timeString.split(':').map(Number);
  const invalidFormat = typeof hours === 'undefined' || typeof minutes === 'undefined' || Number.isNaN(hours) || Number.isNaN(minutes);
  return invalidFormat ? '' : `PT${hours}H${minutes}M`;
}

function fetchFormattedTime() {
  const now = new Date();
  const localTime = new Date(now.toLocaleString('en-US', {
    timeZone: 'America/Sao_Paulo'
  }));
  const year = localTime.getFullYear();
  const month = twoDigitString(localTime.getMonth() + 1);
  const day = twoDigitString(localTime.getDate());
  const hours = twoDigitString(localTime.getHours());
  const minutes = twoDigitString(localTime.getMinutes());
  const seconds = twoDigitString(localTime.getSeconds());
  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
}


// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/carPlateMask.js
var carPlateMask = __webpack_require__(68609);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/animations.js

const slideFromTop = styled_components_browser_esm/* keyframes */.F4`
  from { transform: translateY(-100%); }
  to { transform: translateY(0%); }
`;
const slideFromBottom = styled_components_browser_esm/* keyframes */.F4`
  from { transform: translateY(100%);}
  to { transform: translateY(0); }
`;
const fadeIn = styled_components_browser_esm/* keyframes */.F4`
  from { opacity: 0; }
  to { opacity: 1; }
`;
const scaleUpCenter = styled_components_browser_esm/* keyframes */.F4`
  from { opacity: 0.5; -webkit-transform: scale(0.5); transform: scale(0.5); }
  to { opacity: 1; -webkit-transform: scale(0.5); transform: scale(1); }
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/index.js


























 // animations



/***/ }),

/***/ 97728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12468);


const isInternationalPrice = ({
  currency = _constants__WEBPACK_IMPORTED_MODULE_0__/* .NATIONAL_CURRENCY */ .wp
} = {}) => {
  return currency !== _constants__WEBPACK_IMPORTED_MODULE_0__/* .NATIONAL_CURRENCY */ .wp;
};

/* harmony default export */ __webpack_exports__["Z"] = (isInternationalPrice);

/***/ }),

/***/ 63113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _magalu_stereo_ui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71180);


const moneyMask = value => {
  let parsedValue = value;

  if (typeof value === 'string') {
    parsedValue = value.replace('.', '').replace(',', '').replace(/\D/g, '');
  }

  const currentValue = Number.isNaN(parsedValue) || parsedValue === '' ? 0 : parsedValue;
  const currencyValue = (0,_magalu_stereo_ui_utils__WEBPACK_IMPORTED_MODULE_0__/* .currencyFormatter */ .oB)({
    value: currentValue,
    rightFilling: true
  });
  return {
    amount: currentValue,
    currency: currencyValue
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (moneyMask);

/***/ }),

/***/ 42952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ rotateImage; }
/* harmony export */ });
const jpegFileType = 'image/jpeg';

const generateCanvas = (height, width) => {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  if (height && width) {
    canvas.height = height;
    canvas.width = width;
  }

  return {
    canvas,
    ctx
  };
};

const applyImageRotation = (image, rotation, width, height) => {
  const {
    canvas,
    ctx
  } = generateCanvas(height, width);
  ctx.drawImage(image, 0, 0, width, height);
  const {
    canvas: rotateCanvas,
    ctx: rotateCtx
  } = generateCanvas();
  const shouldRotate = rotation % 180 !== 0;

  if (shouldRotate) {
    rotateCanvas.width = canvas.height;
    rotateCanvas.height = canvas.width;
  } else {
    rotateCanvas.width = canvas.width;
    rotateCanvas.height = canvas.height;
  }

  rotateCtx.translate(rotateCanvas.width / 2, rotateCanvas.height / 2);
  rotateCtx.rotate(rotation * Math.PI / 180);
  rotateCtx.drawImage(canvas, -canvas.width / 2, -canvas.height / 2);
  return rotateCanvas;
};

const rotateImage = (imageUrl, rotation) => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.src = imageUrl;

    image.onload = () => {
      try {
        const rotateCanvas = applyImageRotation(image, rotation, image.width, image.height);
        rotateCanvas.toBlob(blob => {
          if (!blob) {
            reject(new Error('Failed to create blob from canvas.'));
          }

          const rotatedImageFile = new File([blob], 'image.jpeg', {
            type: jpegFileType
          });
          const rotatedImageUrl = URL.createObjectURL(rotatedImageFile);
          resolve(rotatedImageUrl);
        }, jpegFileType);
      } catch (error) {
        reject(error);
      }
    };

    image.onerror = () => reject(new Error('Failed to load image.'));
  });
};

/***/ }),

/***/ 41869:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

const sortBySelected = (items = []) => {
  return items.sort((a, b) => (b == null ? void 0 : b.selected) - (a == null ? void 0 : a.selected));
};

/* harmony default export */ __webpack_exports__["Z"] = (sortBySelected);

/***/ }),

/***/ 82260:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

const sortDescByValue = (items = []) => {
  return items.sort((a, b) => parseFloat(a.value) - parseFloat(b.value)).reverse();
};

/* harmony default export */ __webpack_exports__["Z"] = (sortDescByValue);

/***/ }),

/***/ 7874:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

const zipcodeMask = value => {
  return value.replace(/\D/g, '').replace(/(\d{5})(\d)/, '$1-$2').replace(/(\d{5})(\d{3})/, '$1-$2').replace(/(-\d{3})\d+?$/, '$1');
};

/* harmony default export */ __webpack_exports__["Z"] = (zipcodeMask);

/***/ }),

/***/ 36631:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ memoizeOne; }
/* harmony export */ });
var safeIsNaN = Number.isNaN ||
    function ponyfill(value) {
        return typeof value === 'number' && value !== value;
    };
function isEqual(first, second) {
    if (first === second) {
        return true;
    }
    if (safeIsNaN(first) && safeIsNaN(second)) {
        return true;
    }
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (!isEqual(newInputs[i], lastInputs[i])) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var cache = null;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) {
            return cache.lastResult;
        }
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this,
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}




/***/ })

}]);